// [PHẦN THUẦN — không import moi-truong/workers-types nên giao diện (tsconfig.app) dùng được]
// VClaw (cầu nối Telegram ⇄ Claude Code nhiều hồ sơ của UseAI, repo UseAI: docs/vclaw.md): trạng thái + lịch sử chat do VClaw TỰ ĐẨY
// lên repo riêng `ChatLog` (private). VTask chỉ ĐỌC — không ghi, không D1, không migration. GitHub vẫn là nguồn sự thật.
//   status/vclaw.json                 ảnh chụp: hồ sơ giữ seat, quota từng hồ sơ, việc đang chạy, nhịp tim; v2 thêm `settings` (cài đặt
//                                     chỉ-đọc, KHÔNG bí mật) và `usage` (token + chi phí ước tính gộp theo ngày, 30 ngày); v3 thêm `alerts`, `security`,
//                                     `uptime`, `budget`; đợt lịch chạy thêm `routines` (mã, tên, cron, giờ kế tiếp, kết quả lần cuối — KHÔNG có nội dung lời nhắc);
//                                     đợt đội agent thêm `agents` (danh bạ + trạng thái từng agent), `routines.items[].agent/priority` và `jobs[].agent`;
//                                     đợt phòng tác chiến thêm `warroom` (bật / tắt, địa chỉ GỐC của trang cục bộ, cuộc họp gần nhất, số cuộc họp 7 ngày)
//   chats/YYYY/MM/YYYY-MM-DD.jsonl    một dòng một tin: {ts (UTC), chat, dir: in|out|sys, text, meta}
//   events/YYYY/MM/YYYY-MM-DD.jsonl   một dòng một sự kiện: {ts (UTC), kind, profile?, chat?, model?, text, meta?} (hive mind)
//   warroom/YYYY/MM/YYYY-MM-DD.jsonl  biên bản phòng tác chiến (cuộc họp nhiều agent): {ts (UTC), sid, room: tele|web, who, kind, text ≤ 1500}, một tệp mỗi ngày (giờ VN)
//   memory/index.json                 chỉ mục bộ nhớ của hub (DEC/PAT/ANT/INC/SPEC/SESSION/MEMORY), tối đa 400 mục
// Mọi thứ đọc về đều được LÀM SẠCH (kiểu, độ dài, số hữu hạn) — nội dung là dữ liệu do máy khác ghi, không tin.
// Mọi trường của v2 đều TUỲ CHỌN: thiếu thì mảng đó báo "chưa có dữ liệu", không bao giờ ném lỗi.
export const TOI_DA_DONG = 400;
export const TOI_DA_CHU = 4000;
/** Quá ngưỡng này mà VClaw chưa ghi lại gì thì không còn "đang chạy". Khi rảnh VClaw chỉ ghi lại status/vclaw.json mỗi
 *  chatlog.heartbeat_every_sec = 1800 giây (30 phút) + độ trễ đồng bộ ~2 phút, nên `updated` của một VClaw KHOẺ có thể cũ tới ~33 phút:
 *  ngưỡng 45 phút để không báo nhầm. (Đừng lẫn với telegram.stale_after_sec = 30 phút — đó là tuổi tối đa của TIN NHẮN còn được xử lý.) */
export const PHUT_ONLINE = 45;
export const PHUT_CHAM = 180;
/** Sự kiện là câu tóm tắt ngắn — dài hơn thì cắt (nội dung tin nhắn KHÔNG được ghi vào sự kiện). */
export const TOI_DA_CHU_SU_KIEN = 500;
export const TOI_DA_MUC_BO_NHO = 400;
export const TOI_DA_NGAY_SU_DUNG = 60;
const TOI_DA_HO_SO_NGAY = 20;
const TOI_DA_MODEL_NGAY = 12;
const TRAN_TOKEN = 1e12;
const TRAN_CHI_PHI = 1e6;
const TRAN_VIEC = 1e6;

export type HoSoVclaw = {
  name: string; order: number; seat: boolean; login_ok: boolean; login_note: string;
  five_pct: number | null; five_reset: number | null; seven_pct: number | null; seven_reset: number | null; measured_at: string | null;
  /** Lúc hồ sơ này chạy xong việc gần nhất + số việc hôm nay (VClaw bản mới mới ghi; thiếu = null). */
  last_job_at: string | null; jobs_today: number | null;
};
/** Một việc đang chạy. `agent` = mã agent của đội đang làm việc đó — CHỈ có khoá khi VClaw ghi và đúng dạng (MAU_MA_AGENT): đội tắt / VClaw bản cũ thì vắng khoá. */
export type ViecVclaw = { chat: string; started: string; tool: string; profile: string; queued: number; agent?: string };

/** Cách VClaw đang được chạy (bridge.launch — VClaw bản mới mới ghi). `under_claude` = trong chuỗi tiến trình cha có phiên Claude Code:
 *  VClaw đứng dưới phiên đó sẽ chết theo khi đổi hồ sơ. `ancestors` chỉ là tên tiến trình (không đường dẫn, không dòng lệnh). */
export type CachChayVclaw = { via: 'service' | 'manual'; under_claude: boolean; reason: string; ancestors: string[] };

/** Cài đặt VClaw — CHỈ ĐỌC, không bí mật (không token, không PIN, không cụm từ dừng khẩn: chỉ biết "đã đặt" hay chưa). */
export type CaiDatVclaw = {
  model_default: string; model_effective: string; effort: string;
  model_choices: { alias: string; model: string }[];
  mcp: string; permission_mode: string;
  max_parallel_jobs: number | null; timeout_sec: number | null; idle_timeout_sec: number | null;
  quota: { threshold_5h: number | null; threshold_7d: number | null; switch_when_idle: boolean | null; switch_mid_job: boolean | null };
  security: { pin_set: boolean | null; idle_lock_minutes: number | null; allowed_users: number | null; kill_phrase_set: boolean | null };
  chatlog: { repo: string; sync_every_sec: number | null; redact: boolean | null };
  disallowed_tools: number | null;
};

/** Một hồ sơ trong MỘT ngày (hoặc gộp nhiều ngày). `in`/`out` là token vào/ra; `cost` = USD ƯỚC TÍNH theo giá API. */
export type SuDungHoSo = { name: string; jobs: number; in: number; out: number; cost: number };
export type SuDungModel = { name: string; jobs: number; cost: number };
export type NgaySuDung = {
  day: string; jobs: number; failed: number; in: number; out: number; cache_read: number; cache_write: number; cost: number; secs: number;
  by_profile: SuDungHoSo[]; by_model: SuDungModel[];
};
export type SuDungVclaw = { days: NgaySuDung[] };

/** Cảnh báo do CHÍNH VClaw ghi (status/vclaw.json → `alerts`). `id` ổn định theo điều kiện (cùng điều kiện → cùng id) để trang khử trùng với cảnh báo
 *  suy ra phía trình duyệt. `text`/`hint` có thể nhắc tên hồ sơ (email) → giao diện luôn bọc công tắc che riêng tư. */
export const MUC_CANH_BAO = ['crit', 'warn', 'info'] as const;
export type MucCanhBao = (typeof MUC_CANH_BAO)[number];
export type CanhBaoVclaw = { id: string; level: MucCanhBao; /** ISO UTC; '' = VClaw không ghi */ since: string; text: string; hint: string };

/** Số đếm bảo mật hôm nay + tư thế cấu hình (status/vclaw.json → `security`). Số đếm: null = VClaw không ghi (khác với 0 = ghi và bằng 0). */
export type BaoMatVclaw = {
  blocked_today: number | null; unlock_fail_today: number | null; lockouts_today: number | null; stale_skipped_today: number | null; kills_7d: number | null;
  posture: { pin: boolean | null; kill_phrase: boolean | null; permission_mode: string; mcp: string; disallowed_tools: number | null; redact: boolean | null; stale_after_sec: number | null };
};
/** Độ sẵn sàng (status/vclaw.json → `uptime`): khởi động lúc nào, số lần khởi động lại 24 giờ, nhịp tim. */
export type DoSanSangVclaw = {
  started: string; restarts_24h: number | null; heartbeat_every_sec: number | null;
  /** Số lần khởi động trong 7 ngày qua, KỂ CẢ lần hiện tại (1 = chưa khởi động lại lần nào). VẮNG khoá = VClaw bản cũ chưa ghi ("chưa đo"); null = khoá có nhưng giá trị không đọc được. */
  restarts_7d?: number | null;
  /** Khoảng DỪNG dài nhất (giây) giữa một lần VClaw dừng và lần chạy lại kế tiếp, tính cho các lần chạy lại trong 7 ngày qua. VẮNG khoá = VClaw bản cũ; null = VClaw bản mới chưa đo được
   *  (chưa có lần dừng êm nào) hoặc giá trị sai. CHỈ đo được lần dừng êm (`vclaw stop` / `restart`, tự nạp bản mới, Ctrl+C): mất điện hay `taskkill` không để lại mốc dừng nên không vào số này
   *  — đây là CẬN DƯỚI của khoảng gián đoạn thật. */
  longest_gap_sec_7d?: number | null;
};
/** Ngân sách ngày MỀM (status/vclaw.json → `budget`) — chi phí là USD ƯỚC TÍNH theo giá API, không phải tiền thật phải trả. */
export type NganSachVclaw = { daily_usd_soft: number | null; spent_today: number | null; pct: number | null };

export type TrangThaiVclaw = {
  updated: string;
  holder: string | null;
  profiles: HoSoVclaw[];
  bridge: { version: string; host: string; pid: number; started: string; alive: string; launch: CachChayVclaw | null };
  jobs: ViecVclaw[];
  last_switch: { at: string; from: string; to: string; job: string } | null;
  blocked_until: string | null;
  model: { default: string; effort: string };
  settings: CaiDatVclaw | null;
  usage: SuDungVclaw | null;
  /** v3 — đều null khi VClaw (bản cũ) chưa ghi mục đó. `alerts: []` = VClaw có ghi và không có cảnh báo nào. */
  alerts: CanhBaoVclaw[] | null;
  security: BaoMatVclaw | null;
  uptime: DoSanSangVclaw | null;
  budget: NganSachVclaw | null;
  /** Lịch chạy định kỳ (khối `routines`); null khi VClaw (bản cũ) chưa ghi khối này. */
  routines: LichChayVclaw | null;
  /** Đội agent (khối `agents`); null khi VClaw (bản cũ) chưa ghi khối này. `enabled: false` = VClaw có ghi và đội đang TẮT (khác với null = chưa ghi). */
  agents: AgentsVclaw | null;
  /** Phòng tác chiến (khối `warroom`); null khi VClaw (bản cũ) chưa ghi khối này — KHÔNG phải "tắt". `enabled: false` = VClaw có ghi và phòng đang TẮT. */
  warroom: WarRoomVclaw | null;
};

export const TOI_DA_CANH_BAO = 20;

// ── Lịch chạy định kỳ (status/vclaw.json → `routines`): các lời nhắc VClaw tự chạy theo giờ. KHÔNG có nội dung lời nhắc — chỉ mã, tên, cron, giờ kế tiếp, kết quả lần cuối. ──
export const TOI_DA_LICH = 20;
export const TOI_DA_LOI_LICH = 5;
/** Mã lịch (slug): đối số của lệnh `/chay <mã>` trên Telegram và trường `routine` của sổ cái việc. Chỉ chữ thường, số, `-`, `_`; ≤ 40 ký tự; không bắt đầu bằng `-`/`_`. */
export const MAU_MA_LICH = /^[a-z0-9][a-z0-9_-]{0,39}$/;
/** Kết quả lần chạy cuối của một lịch. ok = chạy xong; fail = lỗi; cancelled = bị /dung; skip-quota = bỏ vì quota 5 giờ cao; skip-late = bỏ vì lỡ giờ quá cửa sổ bù
 *  (máy / VClaw đang tắt); skip-locked = bỏ vì VClaw đang khoá PIN; skip-busy = bỏ vì lần trước chưa xong. Giá trị lạ (VClaw bản mới hơn VTask) → null. */
export const KET_QUA_LICH = ['ok', 'fail', 'cancelled', 'skip-quota', 'skip-late', 'skip-locked', 'skip-busy'] as const;
export type KetQuaLich = (typeof KET_QUA_LICH)[number];
export type MucLichChay = {
  id: string;
  /** thiếu tên → dùng mã */
  name: string;
  /** biểu thức cron của chủ ("30 7 * * 1-5"); hiện nguyên văn, không diễn giải */
  cron: string;
  /** null = VClaw không ghi (khác false = ghi và đang tắt) */
  enabled: boolean | null;
  /** ISO UTC giờ chạy kế tiếp; null = không ghi / không đọc được */
  next: string | null;
  /** ISO UTC lần chạy THẬT gần nhất */
  last_run: string | null;
  last_result: KetQuaLich | null;
  /** ISO UTC lúc ghi kết quả cuối (lần bỏ qua cũng có giờ riêng, khác last_run) */
  last_result_at: string | null;
  /** mã agent đã khai cho lịch (đúng dạng MAU_MA_AGENT); null = lịch không khai agent (khi đội bật, VClaw dùng agent mặc định) HOẶC VClaw (bản cũ) chưa ghi khoá / giá trị sai dạng */
  agent: string | null;
  /** ưu tiên 1–5 (số NHỎ chạy trước khi nhiều lịch cùng đến hạn; VClaw mặc định 3); null = VClaw không ghi hoặc giá trị ngoài 1–5 / không phải số nguyên */
  priority: number | null;
};
export type LichChayVclaw = {
  /** false = chủ chưa bật `scheduler.enabled` (mặc định TẮT) → items rỗng */
  enabled: boolean;
  items: MucLichChay[];
  /** lỗi trong tệp lịch (mỗi lịch sai bị bỏ riêng), tối đa 5 dòng */
  errors: string[];
  /** gửi / nhận tệp qua Telegram đang bật hay tắt; null = VClaw không ghi */
  files: { send: boolean | null; receive: boolean | null };
};

// ── Đội agent (status/vclaw.json → `agents`): danh bạ + trạng thái từng agent do VClaw (bản có đội agent) ghi. KHÔNG có nội dung tin, lời nhắc hay tệp agent: chỉ mã, tên, vai, số đếm, mốc giờ. ──
export const TOI_DA_AGENT = 32;
export const TOI_DA_LOI_AGENT = 5;
/** Mã agent (slug) — khớp `ID_RE` của VClaw (scripts/vclaw/agents.py): chữ thường + số, 2–16 ký tự, bắt đầu bằng chữ. Là đối số của `@mã` / `/doi mã` trên Telegram và trường `agent` của sổ cái, lịch, việc đang chạy. */
export const MAU_MA_AGENT = /^[a-z][a-z0-9]{1,15}$/;
/** Từ khoá của lệnh `/doi`, `/moi` — VClaw không cho dùng làm id agent (agents.RESERVED); danh bạ có id trùng một từ này là dữ liệu sai, bỏ agent đó. */
export const TU_KHOA_AGENT: readonly string[] = ['all', 'default', 'macdinh', 'moi', 'none', 'reset', 'tatca'];
/** Trạng thái một agent: idle = rảnh, running = đang chạy một việc. Giá trị lạ (VClaw bản mới hơn VTask) → 'unknown' — KHÔNG đoán là "rảnh". */
export const TRANG_THAI_AGENT = ['idle', 'running', 'unknown'] as const;
export type TrangThaiAgent = (typeof TRANG_THAI_AGENT)[number];
export type MucAgent = {
  id: string;
  /** thiếu tên → dùng mã */
  name: string;
  /** biểu tượng 1–2 ký tự của danh bạ; rỗng = không có */
  emoji: string;
  role: string;
  state: TrangThaiAgent;
  /** công cụ đang dùng; '' khi rảnh hoặc không ghi */
  tool: string;
  /** số việc đang chờ ở làn của agent; null = VClaw không ghi (khác 0 = ghi và không có việc chờ) */
  queued: number | null;
  /** số việc agent đã chạy hôm nay; null = VClaw không ghi */
  jobs_today: number | null;
  /** ISO UTC lần chạy xong việc gần nhất; null = chưa có / không đọc được */
  last_at: string | null;
  /** kết quả việc gần nhất: true xong, false lỗi, null = chưa có */
  last_ok: boolean | null;
};
export type AgentsVclaw = {
  /** false = đội agent đang TẮT (VClaw chạy như một agent duy nhất) → items rỗng */
  enabled: boolean;
  /** mã agent mặc định (nhận việc không ghi tên agent); null = không có */
  default: string | null;
  /** mã agent đang được ghim ở cuộc chat (lệnh /agent); null = không ghim */
  pinned: string | null;
  items: MucAgent[];
  /** lỗi trong danh bạ (mỗi agent sai bị bỏ riêng), tối đa 5 dòng */
  errors: string[];
};

// ── Phòng tác chiến (status/vclaw.json → `warroom`; biên bản warroom/YYYY/MM/YYYY-MM-DD.jsonl): cuộc họp nhiều agent do VClaw chạy, trang web ĐIỀU KHIỂN chỉ có trên máy chạy VClaw. ──
// VTask chỉ ĐỌC: khối trạng thái (có địa chỉ GỐC của trang cục bộ — KHÔNG token) và biên bản từng ngày. Nội dung biên bản là chữ do agent viết (đã che bí mật phía VClaw) → luôn là DỮ LIỆU.
/** Mã cuộc họp (sid) VClaw sinh: `hop-YYYYMMDD-HHMMSS` (kèm `-2`, `-3` khi hai cuộc họp trùng giây). Nới thành slug chữ thường (không đòi đúng hình `hop-…`) để VClaw đổi dạng mã sau này không làm rơi
 *  cả biên bản; ĐỒNG THỜI chặn mọi giá trị lạ (dấu cách, `/`, `__proto__`…). Chỉ dùng làm khoá của Map / thuộc tính data-, KHÔNG bao giờ làm khoá đối tượng thường. */
export const MAU_MA_HOP = /^[a-z0-9][a-z0-9_-]{0,47}$/;
/** Địa chỉ GỐC của trang phòng tác chiến — CHỈ mở được trên máy chạy VClaw. Giới hạn ở vòng lặp (127.0.0.1 / localhost) + cổng 1–65535, không đường dẫn, không dấu `/` cuối, không truy vấn,
 *  không thông tin đăng nhập, không `javascript:`: dữ liệu do máy khác ghi, địa chỉ này thành thuộc tính `href` trên trang quản trị nên chỉ nhận đúng hình dạng VClaw sinh ra. Sai → null. */
export function diaChiPhongTacChien(v: unknown): string | null {
  if (typeof v !== 'string' || v.length > 40) return null;
  const m = /^http:\/\/(?:127\.0\.0\.1|localhost):([1-9]\d{0,4})$/.exec(v);
  return m && Number(m[1]) <= 65535 ? v : null;
}
export type WarRoomVclaw = {
  /** false = phòng tác chiến đang TẮT (VClaw không mở cổng, không họp) */
  enabled: boolean;
  /** địa chỉ gốc `http://127.0.0.1:CỔNG` (hoặc `localhost`) của trang cục bộ; null = tắt, không ghi, hoặc không đúng hình dạng (xem diaChiPhongTacChien) */
  url: string | null;
  /** máy chủ của trang cục bộ có đang chạy không (KHÔNG phải "đang họp"); null = VClaw không ghi */
  running: boolean | null;
  /** cuộc họp gần nhất — đang họp dở HOẶC vừa xong (VClaw giữ một cuộc họp "hiện tại"); null = chưa họp lần nào kể từ lúc VClaw khởi động. `ts` = lúc BẮT ĐẦU họp. `sid` rỗng khi mã sai dạng. */
  last: { sid: string; ts: string; topic: string; n: number | null } | null;
  /** số cuộc họp đã BẮT ĐẦU trong 7 ngày qua; null = VClaw không ghi */
  meetings_7d: number | null;
};

// ── Sổ cái việc (jobs/YYYY/MM/YYYY-MM-DD.jsonl): MỘT dòng = MỘT việc đã kết thúc. KHÔNG có nội dung tin nhắn. ──
export const TOI_DA_VIEC = 500;
const TOI_DA_CONG_CU_VIEC = 12;
const TRAN_GIAY = 1e7;
const TRAN_DEM_NHO = 1e5;
/** Một dòng sổ cái (việc / mẫu quota) thật chỉ vài trăm byte đến vài KB; dòng dài hơn mức này là rác → bỏ, không parse. */
const TOI_DA_DONG_SO_CAI = 20_000;
/** Lý do một việc không xong. '' = không có lý do (việc xong). Lý do lạ (VClaw bản mới hơn VTask) → 'unknown', không bỏ dòng. */
export const LOAI_LOI_VIEC = ['rate_limit', 'seat_lost', 'login', 'timeout', 'idle', 'quota_trip', 'overloaded', 'no_session', 'bad_model', 'context', 'cancelled', 'crash', 'unknown'] as const;
export type LoaiLoiViec = (typeof LOAI_LOI_VIEC)[number];
export type ViecSoCai = {
  /** ISO UTC lúc kết thúc */
  ts: string;
  /** ISO UTC lúc bắt đầu CHẠY (thiếu → suy ra từ ts − secs) */
  start: string;
  /** giây chờ trong hàng đợi */
  wait: number;
  /** giây chạy */
  secs: number;
  profile: string; model: string;
  ok: boolean;
  /** '' khi xong; không xong mà không có lý do → 'unknown' */
  kind: '' | LoaiLoiViec;
  turns: number;
  /** USD ƯỚC TÍNH theo giá API */
  cost: number;
  tok: { in: number; out: number; cr: number; cw: number };
  /** công cụ dùng nhiều nhất (≤ 12), MẢNG chứ không phải Record để khoá lạ như __proto__ không có đường lọt vào */
  tools: { ten: string; so: number }[];
  denied: number; retries: number; switches: number; resumed: boolean;
  chat: string; sid: string;
  /** quota 5 giờ / 7 ngày (%) lúc việc kết thúc; null = không ghi */
  q5: number | null; q7: number | null;
  /** mã lịch (slug, xem MAU_MA_LICH) — CHỈ có ở việc do lịch chạy định kỳ hoặc lệnh `/chay` tạo ra; vắng mặt (không phải chuỗi rỗng) khi không có hoặc sai dạng */
  routine?: string;
  /** mã agent của đội đã chạy việc này (slug, xem MAU_MA_AGENT) — CHỈ có khi VClaw bật đội agent; vắng mặt (không phải chuỗi rỗng) khi đội tắt, VClaw bản cũ hoặc mã sai dạng */
  agent?: string;
};

// ── Mẫu quota theo thời gian (quota/YYYY/MM/YYYY-MM-DD.jsonl): mỗi dòng một lần đo MỌI hồ sơ ──
export const TOI_DA_MAU_QUOTA = 400;
const TOI_DA_HO_SO_QUOTA = 40;
/** Khoảng xem của biểu đồ quota → độ dài (ms). Khoá lạ không bao giờ khớp (dùng Object.hasOwn). */
export const KHOANG_QUOTA = { '6h': 6 * 3600_000, '24h': 24 * 3600_000, '7d': 7 * 86400_000 } as const;
export type KhoangQuota = keyof typeof KHOANG_QUOTA;
export const laKhoangQuota = (s: unknown): s is KhoangQuota => typeof s === 'string' && Object.hasOwn(KHOANG_QUOTA, s);
/** Một hồ sơ trong MỘT lần đo: tên, % quota 5 giờ (f) và 7 ngày (s), có đang giữ seat không, đăng nhập còn ổn không. */
export type DiemQuotaHoSo = { n: string; f: number | null; s: number | null; seat: boolean; ok: boolean };
export type MauQuota = { ts: string; p: DiemQuotaHoSo[] };
export type DongChat = { ts: string; chat: string; dir: 'in' | 'out' | 'sys'; text: string; meta: Record<string, string | number> };
export type SucKhoeVclaw = 'online' | 'cham' | 'mat-tin-hieu' | 'chua-co';

/** Loại sự kiện của hive mind. Loại lạ (VClaw bản mới hơn VTask) → 'khac', không bỏ dòng. `stale` = VClaw bỏ qua tin Telegram quá cũ ("Bỏ qua 3 tin cũ hơn 30 phút");
 *  `alert` (v3) = VClaw phát một cảnh báo (cùng nội dung với `alerts` trong status/vclaw.json, nhưng còn lại như một dòng lịch sử).
 *  Năm loại sau cùng (VClaw #329): `routine_start` = chạy một lịch (meta `routine`), `routine_skip` = bỏ một lịch (meta `routine`, `result`), `routine_error` = tệp lịch có lỗi,
 *  `file_in` = nhận tệp từ điện thoại (meta `chat`), `file_sent` = gửi tệp về điện thoại (meta `chat`, `n`).
 *  Ba loại sau cùng (VClaw #334, đội agent): `agent_job` = một agent chạy xong / lỗi một việc (meta `agent`, `ok` — VClaw ghi boolean, đây đổi thành 1 / 0 —, `secs`),
 *  `agent_delegate` = một agent giao việc cho agent khác (meta `from`, `to` — mã agent; KHÔNG kèm nội dung việc), `agent_error` = danh bạ agent có lỗi (KHÔNG có meta).
 *  Ba loại cuối (phòng tác chiến): `meeting` = một cuộc họp bắt đầu / xong / bị huỷ (meta `sid`, `n`, `room` | `answered`, `members`, `proposals`, `secs` | `sid`) — câu tóm tắt chỉ có mã và số đếm, KHÔNG có chủ đề;
 *  `warroom_start` = trang cục bộ của phòng tác chiến đã mở (meta `url` — địa chỉ GỐC, không token); `warroom_error` = phòng không mở được, thường vì cổng bận (meta `port`; VClaw và `/hop` ở Telegram vẫn chạy). */
export const LOAI_SU_KIEN = [
  'start', 'stop', 'job_start', 'job_ok', 'job_fail', 'switch', 'quota_wait', 'lock', 'unlock', 'kill', 'stale', 'alert',
  'routine_start', 'routine_skip', 'routine_error', 'file_in', 'file_sent',
  'agent_job', 'agent_delegate', 'agent_error',
  'meeting', 'warroom_start', 'warroom_error',
] as const;
export type LoaiSuKienChuan = (typeof LOAI_SU_KIEN)[number];
export type LoaiSuKien = LoaiSuKienChuan | 'khac';
export type SuKienVclaw = { ts: string; kind: LoaiSuKien; profile: string; chat: string; model: string; text: string; meta: Record<string, string | number> };

/** Kiểu một dòng biên bản phòng tác chiến (VClaw `meeting.py` / `warroom_bridge.py`): hoi = câu hỏi của chủ hoặc chủ đề cuộc họp · tra-loi = câu trả lời (vòng 1, hoặc kết quả một việc được giao) ·
 *  phan-bien = vòng 2 · tong-hop = kết luận của chỉ huy · de-xuat = đề xuất giao việc (KHÔNG tự chạy — chủ bấm mới chạy; `who` = CHỈ HUY là người đề xuất, `text` = "→ 🔎 Nghiên cứu: <việc>" nêu người nhận) · he-thong = thông báo của VClaw ("bỏ người chưa trả lời quá giờ"…).
 *  Kiểu lạ (VClaw bản mới hơn VTask) → 'khac', không bỏ dòng. */
export const KIEU_TIN_HOP = ['hoi', 'tra-loi', 'phan-bien', 'tong-hop', 'de-xuat', 'he-thong'] as const;
export type KieuTinHop = (typeof KIEU_TIN_HOP)[number];
export type KieuTinHopHoacKhac = KieuTinHop | 'khac';
/** Nơi cuộc họp bắt đầu: tele = Telegram, web = trang cục bộ; giá trị lạ → 'khac'. */
export const PHONG_HOP = ['tele', 'web'] as const;
export type PhongHop = (typeof PHONG_HOP)[number] | 'khac';
/** Một dòng biên bản. `sid` rỗng = lời chat thường trong phòng (không thuộc cuộc họp nào) HOẶC mã sai dạng. `who` = 'owner' (chủ) | 'he-thong' | mã agent | '' (không đọc được). `text` nhiều dòng, ≤ TOI_DA_CHU_HOP. */
export type DongHop = { ts: string; sid: string; room: PhongHop; who: string; kind: KieuTinHopHoacKhac; text: string };

export const LOAI_BO_NHO = ['DEC', 'PAT', 'ANT', 'INC', 'SPEC', 'SESSION', 'MEMORY'] as const;
export type LoaiBoNho = (typeof LOAI_BO_NHO)[number];
export type MucBoNho = { id: string; type: LoaiBoNho; title: string; date: string; tags: string[]; summary: string };
export type ChiMucBoNho = { updated: string; hub: string; counts: Record<LoaiBoNho, number>; items: MucBoNho[] };

export const laChu = (v: unknown, toi_da = 200): string => (typeof v === 'string' ? v.slice(0, toi_da) : '');
const laSo = (v: unknown): number | null => (typeof v === 'number' && Number.isFinite(v) ? v : null);
const laIso = (v: unknown): string => (typeof v === 'string' && v.length <= 40 && !Number.isNaN(Date.parse(v)) ? v : '');
const laCo = (v: unknown): boolean | null => (v === true ? true : v === false ? false : null);
const laDoiTuong = (v: unknown): Record<string, unknown> => (v && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : {});

/** Cắt chuỗi không chẻ đôi cặp thay thế (emoji): cắt giữa cặp sẽ để lại ký tự hỏng. */
function catChu(s: string, toi_da: number): string {
  if (s.length <= toi_da) return s;
  const c = s.slice(0, toi_da);
  const cuoi = c.charCodeAt(c.length - 1);
  return cuoi >= 0xd800 && cuoi <= 0xdbff ? c.slice(0, -1) : c;
}
/** Chuỗi MỘT dòng cho nhãn/tóm tắt do máy khác ghi: ký tự điều khiển và khoảng trắng liền nhau thành một dấu cách; quá dài thì cắt (có "…"). */
export function laChuGon(v: unknown, toi_da: number, dau_cat = false): string {
  if (typeof v !== 'string') return '';
  // eslint-disable-next-line no-control-regex
  const s = v.replace(/[\u0000-\u001f\u007f\s]+/g, ' ').trim();
  if (s.length <= toi_da) return s;
  return dau_cat ? catChu(s, toi_da - 1) + '…' : catChu(s, toi_da);
}
/** Văn bản NHIỀU DÒNG do máy khác ghi (câu trả lời của agent trong biên bản): chuẩn hoá xuống dòng về một kiểu, bỏ khoảng trắng cuối dòng, gộp từ 3 dòng trống liền nhau trở lên thành 1 dòng trống,
 *  bỏ mọi ký tự điều khiển khác (giữ xuống dòng và tab), cắt hai đầu, cắt ở `toi_da` ký tự (kèm …, không chẻ đôi cặp thay thế). Không phải chuỗi → ''.
 *  Duyệt theo mã ký tự (không dùng mã thoát \u trong nguồn: công cụ ghi tệp có thể đổi chúng thành ký tự thật). Chỉ xét phần đầu dài gấp 4 lần `toi_da` — chuỗi rác cực dài không tốn CPU. */
export function laVanBanDai(v: unknown, toi_da: number): string {
  if (typeof v !== 'string') return '';
  const dau = v.length > toi_da * 4 ? v.slice(0, toi_da * 4) : v;
  let ra = '';
  for (let i = 0; i < dau.length; i++) {
    const ma = dau.charCodeAt(i);
    if (ma === 13) { if (dau.charCodeAt(i + 1) !== 10) ra += '\n'; continue; }
    if (ma === 10 || ma === 9 || (ma >= 32 && ma !== 127)) ra += dau[i];
  }
  const s = ra.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
  return s.length <= toi_da ? s : catChu(s, Math.max(0, toi_da - 1)) + '…';
}
/** Số không âm, hữu hạn, có trần — kiểu sai hoặc NaN/Infinity → 0. */
const soKhongAm = (v: unknown, tran: number): number => (typeof v === 'number' && Number.isFinite(v) && v > 0 ? Math.min(v, tran) : 0);
const soNguyenKhongAm = (v: unknown, tran: number): number => Math.round(soKhongAm(v, tran));
/** Như trên nhưng thiếu/sai kiểu → null (cho trường mà "không biết" khác "bằng 0"). */
const soHoacNull = (v: unknown, tran: number): number | null => {
  const n = laSo(v);
  return n === null ? null : Math.min(Math.max(n, 0), tran);
};
const soNguyenHoacNull = (v: unknown, tran: number): number | null => {
  const n = soHoacNull(v, tran);
  return n === null ? null : Math.round(n);
};

/** Khoá meta mà VClaw ghi là boolean: giữ lại dưới dạng 1 / 0 để meta vẫn là Record<string, string | number> (meta.ok của sự kiện agent_job). Boolean ở khoá khác vẫn bị bỏ. */
const KHOA_META_BOOLEAN: readonly string[] = ['ok'];

/** meta của một dòng: chỉ khoá an toàn, chỉ số hữu hạn hoặc chuỗi ngắn (khoá `__proto__` bỏ luôn); boolean chỉ ở khoá KHOA_META_BOOLEAN (→ 1 / 0). */
function lamSachMeta(m: unknown): Record<string, string | number> {
  const meta: Record<string, string | number> = {};
  for (const [k, v] of Object.entries(laDoiTuong(m)).slice(0, 12)) {
    if (!/^[a-z_]{1,24}$/.test(k) || k === '__proto__') continue;
    if (typeof v === 'number' && Number.isFinite(v)) meta[k] = v;
    else if (typeof v === 'string') meta[k] = v.slice(0, 120);
    else if (typeof v === 'boolean' && KHOA_META_BOOLEAN.includes(k)) meta[k] = v ? 1 : 0;
  }
  return meta;
}

/** bridge.launch → CachChayVclaw. Không phải đối tượng, hoặc `via` ngoài {service, manual} (VClaw bản mới hơn VTask) → null = "chưa rõ cách chạy". */
export function lamSachCachChay(tho: unknown): CachChayVclaw | null {
  const l = laDoiTuong(tho);
  const via = l.via === 'service' || l.via === 'manual' ? l.via : null;
  if (!via) return null;
  const ancestors: string[] = [];
  if (Array.isArray(l.ancestors)) {
    for (const a of l.ancestors.slice(0, 40)) { // quét có trần; tối đa 6 tên hợp lệ (phần tử rác không chiếm chỗ của tên thật)
      const ten = laChuGon(a, 60);
      if (ten) ancestors.push(ten);
      if (ancestors.length >= 6) break;
    }
  }
  return { via, under_claude: l.under_claude === true, reason: laChuGon(l.reason, 200, true), ancestors };
}

export type KieuChayVclaw = { muc: 'tot' | 'canh-bao' | 'loi' | 'chua-ro'; nhan: string };
/** Cách chạy → mức cảnh báo + nhãn tiếng Việt. Dưới phiên Claude luôn là 'loi' (kể cả khi `via` nói ngược lại: báo nhầm còn hơn bảo đảm nhầm).
 *  Thiếu / sai dạng → 'chua-ro'. Nhận cả giá trị chưa làm sạch mà không ném lỗi. */
export function kieuChayVclaw(launch: CachChayVclaw | null | undefined): KieuChayVclaw {
  const l = laDoiTuong(launch);
  if (l.under_claude === true) return { muc: 'loi', nhan: 'Chạy trong phiên Claude — sẽ dừng khi đổi hồ sơ' };
  if (l.via === 'service') return { muc: 'tot', nhan: 'Tác vụ nền Windows (an toàn khi đổi hồ sơ)' };
  if (l.via === 'manual') return { muc: 'canh-bao', nhan: 'Chạy tay trong một cửa sổ — đóng cửa sổ là dừng' };
  return { muc: 'chua-ro', nhan: 'Chưa rõ cách chạy' };
}

/** Số phút VClaw im lặng (kể từ `updated`) nếu QUÁ `nguong_phut` (mặc định 45 = PHUT_ONLINE: một nhịp tim 30 phút + độ trễ đồng bộ + dự phòng);
 *  chưa quá, hoặc chưa có/sai ngày → null. Dùng cho banner "VClaw không phản hồi" — khớp `sucKhoe`: có số ⇔ không còn "online". */
export function vclawKhongPhanHoi(updated_iso: string | null | undefined, bay_gio: number, nguong_phut = PHUT_ONLINE): number | null {
  if (typeof updated_iso !== 'string' || !Number.isFinite(bay_gio)) return null;
  const p = tuoiPhut(updated_iso, bay_gio);
  const nguong = Number.isFinite(nguong_phut) && nguong_phut >= 0 ? nguong_phut : PHUT_ONLINE;
  return p !== null && p > nguong ? p : null;
}

/** settings của status/vclaw.json. Chỉ nhặt khoá đã biết (nên dù VClaw lỡ ghi thêm gì cũng không lên trang); không có gì đọc được → null. */
export function lamSachCaiDat(tho: unknown): CaiDatVclaw | null {
  if (!tho || typeof tho !== 'object' || Array.isArray(tho)) return null;
  const s = tho as Record<string, unknown>;
  const q = laDoiTuong(s.quota), b = laDoiTuong(s.security), c = laDoiTuong(s.chatlog);
  const lua_chon: { alias: string; model: string }[] = [];
  for (const [alias, model] of Object.entries(laDoiTuong(s.model_choices)).slice(0, 12)) {
    const a = laChuGon(alias, 24), m = laChuGon(model, 80);
    if (a && m) lua_chon.push({ alias: a, model: m });
  }
  const kq: CaiDatVclaw = {
    model_default: laChuGon(s.model_default, 80), model_effective: laChuGon(s.model_effective, 80), effort: laChuGon(s.effort, 20),
    model_choices: lua_chon,
    mcp: laChuGon(s.mcp, 40), permission_mode: laChuGon(s.permission_mode, 40),
    max_parallel_jobs: soHoacNull(s.max_parallel_jobs, 1000), timeout_sec: soHoacNull(s.timeout_sec, 1e7), idle_timeout_sec: soHoacNull(s.idle_timeout_sec, 1e7),
    quota: { threshold_5h: soHoacNull(q.threshold_5h, 100), threshold_7d: soHoacNull(q.threshold_7d, 100), switch_when_idle: laCo(q.switch_when_idle), switch_mid_job: laCo(q.switch_mid_job) },
    security: { pin_set: laCo(b.pin_set), idle_lock_minutes: soHoacNull(b.idle_lock_minutes, 1e5), allowed_users: soHoacNull(b.allowed_users, 1e4), kill_phrase_set: laCo(b.kill_phrase_set) },
    chatlog: { repo: laChuGon(c.repo, 100), sync_every_sec: soHoacNull(c.sync_every_sec, 1e6), redact: laCo(c.redact) },
    disallowed_tools: soHoacNull(s.disallowed_tools, 1e4),
  };
  const gia_tri: unknown[] = [
    kq.model_default, kq.model_effective, kq.effort, kq.mcp, kq.permission_mode, kq.max_parallel_jobs, kq.timeout_sec, kq.idle_timeout_sec,
    kq.quota.threshold_5h, kq.quota.threshold_7d, kq.quota.switch_when_idle, kq.quota.switch_mid_job,
    kq.security.pin_set, kq.security.idle_lock_minutes, kq.security.allowed_users, kq.security.kill_phrase_set,
    kq.chatlog.repo, kq.chatlog.sync_every_sec, kq.chatlog.redact, kq.disallowed_tools,
  ];
  return lua_chon.length > 0 || gia_tri.some((v) => v !== '' && v !== null) ? kq : null;
}

export const laNgayHopLe = (s: string) => /^\d{4}-\d{2}-\d{2}$/.test(s) && !Number.isNaN(Date.parse(s + 'T00:00:00Z')) && new Date(s + 'T00:00:00Z').toISOString().startsWith(s);

/** Ngày YYYY-MM-DD theo giờ Việt Nam (UTC+7): VClaw đặt tên tệp theo ngày giờ máy của chủ, còn `ts` bên trong là UTC. */
export const homNayVn = (bay_gio: number = Date.now()): string => new Date(bay_gio + 7 * 3600_000).toISOString().slice(0, 10);
/** Cộng/trừ ngày trên chuỗi YYYY-MM-DD (tính theo UTC nên không lệch vì giờ mùa hè hay múi giờ máy). */
export const congNgay = (ngay: string, so: number): string => new Date(Date.parse(ngay + 'T00:00:00Z') + so * 86400_000).toISOString().slice(0, 10);
/** Ngày xin xem biên bản phòng tác chiến: đúng YYYY-MM-DD có thật VÀ không quá hôm nay (giờ Việt Nam) cộng 1 ngày — chừa độ lệch múi giờ / đồng hồ. VClaw không thể có biên bản của tương lai,
 *  nên ngày xa hơn là tham số sai (400, KHÔNG gọi GitHub). Ngày quá khứ xa thì cứ hỏi — không có tệp thì trả "chưa có", không phải lỗi. */
export const laNgayHopXem = (s: string, bay_gio: number = Date.now()): boolean => laNgayHopLe(s) && s <= congNgay(homNayVn(bay_gio), 1);

function lamSachNgaySuDung(tho: unknown): NgaySuDung | null {
  if (!tho || typeof tho !== 'object' || Array.isArray(tho)) return null;
  const d = tho as Record<string, unknown>;
  if (typeof d.day !== 'string' || !laNgayHopLe(d.day)) return null;
  const theo_ho_so = new Map<string, SuDungHoSo>();
  for (const [ten, v] of Object.entries(laDoiTuong(d.by_profile)).slice(0, TOI_DA_HO_SO_NGAY)) {
    const name = laChuGon(ten, 80);
    if (!name || !v || typeof v !== 'object' || Array.isArray(v)) continue;
    const o = v as Record<string, unknown>;
    const cu = theo_ho_so.get(name) ?? { name, jobs: 0, in: 0, out: 0, cost: 0 };
    theo_ho_so.set(name, { name, jobs: cu.jobs + soNguyenKhongAm(o.jobs, TRAN_VIEC), in: cu.in + soKhongAm(o.in, TRAN_TOKEN), out: cu.out + soKhongAm(o.out, TRAN_TOKEN), cost: cu.cost + soKhongAm(o.cost, TRAN_CHI_PHI) });
  }
  const theo_model = new Map<string, SuDungModel>();
  for (const [ten, v] of Object.entries(laDoiTuong(d.by_model)).slice(0, TOI_DA_MODEL_NGAY)) {
    const name = laChuGon(ten, 80);
    if (!name || !v || typeof v !== 'object' || Array.isArray(v)) continue;
    const o = v as Record<string, unknown>;
    const cu = theo_model.get(name) ?? { name, jobs: 0, cost: 0 };
    theo_model.set(name, { name, jobs: cu.jobs + soNguyenKhongAm(o.jobs, TRAN_VIEC), cost: cu.cost + soKhongAm(o.cost, TRAN_CHI_PHI) });
  }
  return {
    day: d.day, jobs: soNguyenKhongAm(d.jobs, TRAN_VIEC), failed: soNguyenKhongAm(d.failed, TRAN_VIEC),
    in: soKhongAm(d.in, TRAN_TOKEN), out: soKhongAm(d.out, TRAN_TOKEN), cache_read: soKhongAm(d.cache_read, TRAN_TOKEN), cache_write: soKhongAm(d.cache_write, TRAN_TOKEN),
    cost: soKhongAm(d.cost, TRAN_CHI_PHI), secs: soKhongAm(d.secs, TRAN_TOKEN),
    by_profile: [...theo_ho_so.values()], by_model: [...theo_model.values()],
  };
}

/** usage của status/vclaw.json → các ngày hợp lệ, tăng dần, tối đa 60 ngày gần nhất; trùng ngày thì dòng sau thắng. Sai dạng → null. */
export function lamSachSuDung(tho: unknown): SuDungVclaw | null {
  const t = laDoiTuong(tho);
  if (!Array.isArray(t.days)) return null;
  const theo_ngay = new Map<string, NgaySuDung>();
  for (const x of t.days.slice(-400)) {
    const n = lamSachNgaySuDung(x);
    if (n) theo_ngay.set(n.day, n);
  }
  const days = [...theo_ngay.values()].sort((a, b) => (a.day < b.day ? -1 : a.day > b.day ? 1 : 0)).slice(-TOI_DA_NGAY_SU_DUNG);
  return { days };
}

/** Làm sạch status/vclaw.json. Sai dạng → null (trang báo chưa có dữ liệu, không ném lỗi). */
export function lamSachTrangThai(tho: unknown): TrangThaiVclaw | null {
  if (!tho || typeof tho !== 'object' || Array.isArray(tho)) return null;
  const t = tho as Record<string, unknown>;
  const updated = laIso(t.updated);
  if (!updated) return null;
  const profiles: HoSoVclaw[] = [];
  if (Array.isArray(t.profiles)) {
    for (const p of t.profiles.slice(0, 40)) {
      if (!p || typeof p !== 'object') continue;
      const h = p as Record<string, unknown>;
      const name = laChu(h.name, 80);
      if (!name) continue;
      profiles.push({
        name, order: laSo(h.order) ?? 0, seat: h.seat === true, login_ok: h.login_ok === true, login_note: laChu(h.login_note, 120),
        five_pct: laSo(h.five_pct), five_reset: laSo(h.five_reset), seven_pct: laSo(h.seven_pct), seven_reset: laSo(h.seven_reset),
        measured_at: laIso(h.measured_at) || null,
        last_job_at: laIso(h.last_job_at) || null, jobs_today: soNguyenHoacNull(h.jobs_today, TRAN_VIEC),
      });
    }
  }
  const b = (t.bridge && typeof t.bridge === 'object' ? t.bridge : {}) as Record<string, unknown>;
  const jobs: ViecVclaw[] = [];
  if (Array.isArray(t.jobs)) {
    for (const j of t.jobs.slice(0, 20)) {
      if (!j || typeof j !== 'object') continue;
      const v = j as Record<string, unknown>;
      const agent = laMaAgent(v.agent);
      jobs.push({
        chat: laChu(v.chat, 40), started: laIso(v.started), tool: laChu(v.tool, 60), profile: laChu(v.profile, 80), queued: Math.max(0, laSo(v.queued) ?? 0),
        ...(agent ? { agent } : {}), // CHỈ thêm khoá khi mã hợp lệ: việc của VClaw không bật đội agent không có trường `agent`
      });
    }
  }
  const ls = t.last_switch && typeof t.last_switch === 'object' ? (t.last_switch as Record<string, unknown>) : null;
  const m = (t.model && typeof t.model === 'object' ? t.model : {}) as Record<string, unknown>;
  return {
    updated,
    holder: laChu(t.holder, 80) || null,
    profiles,
    bridge: { version: laChu(b.version, 20), host: laChu(b.host, 80), pid: laSo(b.pid) ?? 0, started: laIso(b.started), alive: laIso(b.alive), launch: lamSachCachChay(b.launch) },
    jobs,
    last_switch: ls ? { at: laIso(ls.at), from: laChu(ls.from, 80), to: laChu(ls.to, 80), job: laChu(ls.job, 60) } : null,
    blocked_until: laIso(t.blocked_until) || null,
    model: { default: laChu(m.default, 80), effort: laChu(m.effort, 20) },
    settings: lamSachCaiDat(t.settings),
    usage: lamSachSuDung(t.usage),
    alerts: lamSachCanhBao(t.alerts),
    security: lamSachBaoMat(t.security),
    uptime: lamSachDoSanSang(t.uptime),
    budget: lamSachNganSach(t.budget),
    routines: lamSachLichChay(t.routines),
    agents: lamSachAgents(t.agents),
    warroom: lamSachWarRoom(t.warroom),
  };
}

/** alerts của status/vclaw.json → tối đa 20 cảnh báo hợp lệ. Không phải mảng → null ("VClaw chưa ghi cảnh báo"); mảng rỗng → [] ("không có cảnh báo").
 *  Bỏ mục không có chữ; không có id → "vclaw-<số thứ tự>"; trùng id giữ mục đầu; mức lạ → 'info' (không leo thang, cũng không giấu). */
export function lamSachCanhBao(tho: unknown): CanhBaoVclaw[] | null {
  if (!Array.isArray(tho)) return null;
  const ra: CanhBaoVclaw[] = [];
  const da_co = new Set<string>();
  for (const x of tho.slice(0, 100)) { // quét có trần: phần tử rác không chiếm chỗ của cảnh báo thật
    if (ra.length >= TOI_DA_CANH_BAO) break;
    const o = laDoiTuong(x);
    const text = laChuGon(o.text, 300, true);
    if (!text) continue;
    const id = laChuGon(o.id, 60) || `vclaw-${ra.length + 1}`;
    if (da_co.has(id)) continue;
    da_co.add(id);
    ra.push({ id, level: (MUC_CANH_BAO as readonly unknown[]).includes(o.level) ? (o.level as MucCanhBao) : 'info', since: laIso(o.since), text, hint: laChuGon(o.hint, 300, true) });
  }
  return ra;
}

/** security của status/vclaw.json. Chỉ nhặt khoá đã biết (số đếm + cờ "đã đặt", không bao giờ có PIN hay câu tắt khẩn thật). Không đọc được gì → null. */
export function lamSachBaoMat(tho: unknown): BaoMatVclaw | null {
  if (!tho || typeof tho !== 'object' || Array.isArray(tho)) return null;
  const s = tho as Record<string, unknown>;
  const p = laDoiTuong(s.posture);
  const kq: BaoMatVclaw = {
    blocked_today: soNguyenHoacNull(s.blocked_today, TRAN_VIEC), unlock_fail_today: soNguyenHoacNull(s.unlock_fail_today, TRAN_VIEC),
    lockouts_today: soNguyenHoacNull(s.lockouts_today, TRAN_VIEC), stale_skipped_today: soNguyenHoacNull(s.stale_skipped_today, TRAN_VIEC),
    kills_7d: soNguyenHoacNull(s.kills_7d, TRAN_VIEC),
    posture: {
      pin: laCo(p.pin), kill_phrase: laCo(p.kill_phrase), permission_mode: laChuGon(p.permission_mode, 40), mcp: laChuGon(p.mcp, 40),
      disallowed_tools: soNguyenHoacNull(p.disallowed_tools, 1e4), redact: laCo(p.redact), stale_after_sec: soNguyenHoacNull(p.stale_after_sec, TRAN_GIAY),
    },
  };
  const gia_tri: unknown[] = [
    kq.blocked_today, kq.unlock_fail_today, kq.lockouts_today, kq.stale_skipped_today, kq.kills_7d,
    kq.posture.pin, kq.posture.kill_phrase, kq.posture.permission_mode, kq.posture.mcp, kq.posture.disallowed_tools, kq.posture.redact, kq.posture.stale_after_sec,
  ];
  return gia_tri.some((v) => v !== '' && v !== null) ? kq : null;
}

/** Số nguyên không âm có trần cho số liệu ĐẾM THẬT (khởi động lại, giây dừng): kiểu sai / âm / không hữu hạn → null — KHÔNG ép về 0, vì "0 lần" là con số làm người đọc yên tâm giả.
 *  Vượt trần thì chặn ở trần (con số vô lý nhìn là biết dữ liệu hỏng); làm tròn; -0 thành 0. */
const soDemHoacNull = (v: unknown, tran: number): number | null => {
  const n = laSo(v);
  return n === null || n < 0 ? null : Math.round(Math.min(n, tran)) || 0;
};

/** uptime của status/vclaw.json → null khi không đọc được trường nào.
 *  Hai số của 7 ngày (VClaw UseAI #333) chỉ có trong kết quả khi VClaw CÓ ghi khoá: vắng khoá (bản cũ) ≠ khoá có mà null (bản mới, chưa đo được) ≠ khoá có mà sai (→ null);
 *  giao diện cần phân biệt "VClaw cũ, cập nhật đi" với "VClaw mới, chưa có lần dừng êm nào". */
export function lamSachDoSanSang(tho: unknown): DoSanSangVclaw | null {
  if (!tho || typeof tho !== 'object' || Array.isArray(tho)) return null;
  const u = tho as Record<string, unknown>;
  const kq: DoSanSangVclaw = { started: laIso(u.started), restarts_24h: soNguyenHoacNull(u.restarts_24h, TRAN_DEM_NHO), heartbeat_every_sec: soNguyenHoacNull(u.heartbeat_every_sec, 1e6) };
  if (Object.hasOwn(u, 'restarts_7d')) kq.restarts_7d = soDemHoacNull(u.restarts_7d, TRAN_DEM_NHO);
  if (Object.hasOwn(u, 'longest_gap_sec_7d')) kq.longest_gap_sec_7d = soDemHoacNull(u.longest_gap_sec_7d, TRAN_GIAY);
  const doc_duoc = kq.started !== '' || kq.restarts_24h !== null || kq.heartbeat_every_sec !== null || (kq.restarts_7d ?? null) !== null || (kq.longest_gap_sec_7d ?? null) !== null;
  return doc_duoc ? kq : null;
}

/** budget của status/vclaw.json → null khi không đọc được trường nào. `pct` có thể > 100 (vượt ngân sách mềm), tối đa 10 000. */
export function lamSachNganSach(tho: unknown): NganSachVclaw | null {
  if (!tho || typeof tho !== 'object' || Array.isArray(tho)) return null;
  const b = tho as Record<string, unknown>;
  const kq: NganSachVclaw = { daily_usd_soft: soHoacNull(b.daily_usd_soft, TRAN_CHI_PHI), spent_today: soHoacNull(b.spent_today, TRAN_CHI_PHI), pct: soHoacNull(b.pct, 1e4) };
  return kq.daily_usd_soft !== null || kq.spent_today !== null || kq.pct !== null ? kq : null;
}

/** Mã lịch hợp lệ (xem MAU_MA_LICH) hoặc '' — không cắt, không sửa: mã sai dạng thì không dùng được cho `/chay <mã>` nên bỏ hẳn. */
const laMaLich = (v: unknown): string => (typeof v === 'string' && MAU_MA_LICH.test(v) ? v : '');
/** Mã agent hợp lệ (xem MAU_MA_AGENT) hoặc '' — không cắt, không sửa: mã sai dạng thì không dùng được cho `@mã` / `/doi mã` nên bỏ hẳn (kể cả `__proto__`). */
const laMaAgent = (v: unknown): string => (typeof v === 'string' && MAU_MA_AGENT.test(v) ? v : '');
/** Ưu tiên của một lịch: số nguyên 1–5 hoặc null. Không ép kiểu, không làm tròn, không kẹp vào khoảng (VClaw từ chối nạp lịch có ưu tiên ngoài 1–5 nên giá trị lạ là dữ liệu sai). */
const laUuTienLich = (v: unknown): number | null => (typeof v === 'number' && Number.isInteger(v) && v >= 1 && v <= 5 ? v : null);

/** routines của status/vclaw.json → LichChayVclaw. Không phải đối tượng, hoặc đối tượng mà không đọc được trường nào → null ("VClaw chưa ghi khối lịch chạy").
 *  Chỉ nhặt khoá đã biết (nội dung lời nhắc lỡ có trong dữ liệu cũng không lên trang). Lịch: tối đa 20, quét có trần (phần tử rác không chiếm chỗ của lịch thật);
 *  mã sai dạng hoặc trùng mã (giữ lịch đầu) bị bỏ; thiếu tên → dùng mã; kết quả lạ → null; mốc giờ là ISO hợp lệ hoặc null; cờ chỉ true/false/null.
 *  `errors`: tối đa 5 dòng, mỗi dòng MỘT dòng ≤ 160 ký tự. `enabled` không phải boolean → suy từ việc có lịch hay không (VClaw chỉ liệt kê lịch khi scheduler đang bật). */
export function lamSachLichChay(tho: unknown): LichChayVclaw | null {
  if (!tho || typeof tho !== 'object' || Array.isArray(tho)) return null;
  const r = tho as Record<string, unknown>;
  const items: MucLichChay[] = [];
  const da_co = new Set<string>();
  if (Array.isArray(r.items)) {
    for (const x of r.items.slice(0, 100)) {
      if (items.length >= TOI_DA_LICH) break;
      const o = laDoiTuong(x);
      const id = laMaLich(o.id);
      if (!id || da_co.has(id)) continue;
      da_co.add(id);
      const kq = typeof o.last_result === 'string' && (KET_QUA_LICH as readonly string[]).includes(o.last_result) ? (o.last_result as KetQuaLich) : null;
      items.push({
        id, name: laChuGon(o.name, 80, true) || id, cron: laChuGon(o.cron, 80), enabled: laCo(o.enabled),
        next: laIso(o.next) || null, last_run: laIso(o.last_run) || null, last_result: kq, last_result_at: laIso(o.last_result_at) || null,
        agent: laMaAgent(o.agent) || null, priority: laUuTienLich(o.priority),
      });
    }
  }
  const errors: string[] = [];
  if (Array.isArray(r.errors)) {
    for (const e of r.errors.slice(0, 50)) {
      const dong = laChuGon(e, 160, true);
      if (dong) errors.push(dong);
      if (errors.length >= TOI_DA_LOI_LICH) break;
    }
  }
  const f = laDoiTuong(r.files);
  const files = { send: laCo(f.send), receive: laCo(f.receive) };
  const bat = laCo(r.enabled);
  if (bat === null && items.length === 0 && errors.length === 0 && files.send === null && files.receive === null) return null;
  return { enabled: bat ?? items.length > 0, items, errors, files };
}

/** agents của status/vclaw.json → AgentsVclaw. Không phải đối tượng, hoặc đối tượng mà không đọc được trường nào → null ("VClaw chưa ghi khối agents").
 *  Chỉ nhặt khoá đã biết (nội dung lời nhắc / tệp agent lỡ lọt vào dữ liệu cũng không lên trang). Agent: tối đa 32, quét có trần (phần tử rác không chiếm chỗ của agent thật);
 *  mã sai dạng (MAU_MA_AGENT), trùng từ khoá lệnh (TU_KHOA_AGENT) hoặc trùng mã (giữ agent đầu) bị bỏ; thiếu tên → dùng mã; trạng thái lạ → 'unknown' (không đoán "rảnh");
 *  số đếm không đọc được → null (khác 0); mốc giờ là ISO hợp lệ hoặc null; cờ chỉ true / false / null. `default` / `pinned`: mã hợp lệ hoặc null.
 *  `errors`: tối đa 5 dòng, mỗi dòng MỘT dòng ≤ 160 ký tự. `enabled` không phải boolean → suy từ việc có agent hay không (VClaw chỉ liệt kê agent khi đội đang bật). */
export function lamSachAgents(tho: unknown): AgentsVclaw | null {
  if (!tho || typeof tho !== 'object' || Array.isArray(tho)) return null;
  const r = tho as Record<string, unknown>;
  const items: MucAgent[] = [];
  const da_co = new Set<string>();
  if (Array.isArray(r.items)) {
    for (const x of r.items.slice(0, 100)) {
      if (items.length >= TOI_DA_AGENT) break;
      const o = laDoiTuong(x);
      const id = laMaAgent(o.id);
      if (!id || TU_KHOA_AGENT.includes(id) || da_co.has(id)) continue;
      da_co.add(id);
      items.push({
        id, name: laChuGon(o.name, 40, true) || id, emoji: laChuGon(o.emoji, 8), role: laChuGon(o.role, 160, true),
        state: o.state === 'idle' || o.state === 'running' ? o.state : 'unknown',
        tool: laChuGon(o.tool, 60),
        queued: soNguyenHoacNull(o.queued, TRAN_VIEC), jobs_today: soNguyenHoacNull(o.jobs_today, TRAN_VIEC),
        last_at: laIso(o.last_at) || null, last_ok: laCo(o.last_ok),
      });
    }
  }
  const errors: string[] = [];
  if (Array.isArray(r.errors)) {
    for (const e of r.errors.slice(0, 50)) {
      const dong = laChuGon(e, 160, true);
      if (dong) errors.push(dong);
      if (errors.length >= TOI_DA_LOI_AGENT) break;
    }
  }
  const mac_dinh = laMaAgent(r.default) || null, ghim = laMaAgent(r.pinned) || null;
  const bat = laCo(r.enabled);
  if (bat === null && items.length === 0 && errors.length === 0 && mac_dinh === null && ghim === null) return null;
  return { enabled: bat ?? items.length > 0, default: mac_dinh, pinned: ghim, items, errors };
}

/** warroom của status/vclaw.json → WarRoomVclaw. Không phải đối tượng, hoặc `enabled` không phải true / false → null ("VClaw chưa ghi khối warroom" — KHÔNG đoán là tắt, cũng không đoán là bật).
 *  Chỉ nhặt khoá đã biết. `url`: chỉ địa chỉ gốc vòng lặp (diaChiPhongTacChien), còn lại null; phòng TẮT thì `url` luôn null và `running` luôn false (không để một địa chỉ cũ lọt ra như đang dùng được).
 *  `last`: cần ít nhất một trong `ts` (ISO hợp lệ) hoặc `sid` (đúng MAU_MA_HOP) — chủ đề MỘT dòng ≤ 120 ký tự, số thành viên số nguyên ≥ 0 hoặc null. Số đếm không đọc được → null (khác 0). */
export function lamSachWarRoom(tho: unknown): WarRoomVclaw | null {
  if (!tho || typeof tho !== 'object' || Array.isArray(tho)) return null;
  const r = tho as Record<string, unknown>;
  const bat = laCo(r.enabled);
  if (bat === null) return null;
  const l = laDoiTuong(r.last);
  const sid = typeof l.sid === 'string' && MAU_MA_HOP.test(l.sid) ? l.sid : '';
  const ts = laIso(l.ts);
  return {
    enabled: bat,
    url: bat ? diaChiPhongTacChien(r.url) : null,
    running: bat ? laCo(r.running) : false,
    last: ts || sid ? { sid, ts, topic: laChuGon(l.topic, 120, true), n: soNguyenHoacNull(l.n, 1000) } : null,
    meetings_7d: soNguyenHoacNull(r.meetings_7d, TRAN_VIEC),
  };
}

/** Tuổi của lần ghi trạng thái cuối, tính bằng phút; không đọc được → null. */
export function tuoiPhut(iso: string, bay_gio: number): number | null {
  const t = Date.parse(iso);
  return Number.isNaN(t) ? null : Math.max(0, Math.floor((bay_gio - t) / 60_000));
}

export function sucKhoe(tt: TrangThaiVclaw | null, bay_gio: number): SucKhoeVclaw {
  if (!tt) return 'chua-co';
  const p = tuoiPhut(tt.updated, bay_gio);
  if (p === null) return 'chua-co';
  return p <= PHUT_ONLINE ? 'online' : p <= PHUT_CHAM ? 'cham' : 'mat-tin-hieu';
}

/** Một dòng JSONL → DongChat; dòng hỏng → null. */
export function lamSachDong(dong: string): DongChat | null {
  let j: unknown;
  try { j = JSON.parse(dong); } catch { return null; }
  if (!j || typeof j !== 'object' || Array.isArray(j)) return null;
  const h = j as Record<string, unknown>;
  const ts = laIso(h.ts);
  if (!ts) return null;
  const dir = h.dir === 'in' || h.dir === 'out' ? h.dir : 'sys';
  let text = typeof h.text === 'string' ? h.text : '';
  if (text.length > TOI_DA_CHU) text = text.slice(0, TOI_DA_CHU) + '… (đã cắt bớt)';
  return { ts, chat: laChu(h.chat, 40), dir, text, meta: lamSachMeta(h.meta) };
}

/** Cả file JSONL của một ngày → các dòng MỚI NHẤT (giữ thứ tự cũ → mới), kèm tổng số dòng đọc được. */
export function lamSachNgay(tho: string): { ds: DongChat[]; tong: number } {
  const tat_ca: DongChat[] = [];
  for (const dong of tho.split('\n')) {
    if (!dong.trim()) continue;
    const d = lamSachDong(dong);
    if (d) tat_ca.push(d);
  }
  return { ds: tat_ca.slice(-TOI_DA_DONG), tong: tat_ca.length };
}

/** Một dòng JSONL của events/ → SuKienVclaw; dòng hỏng (không phải JSON, không có ts hợp lệ) → null. Loại lạ → 'khac'. */
export function lamSachSuKien(dong: string): SuKienVclaw | null {
  let j: unknown;
  try { j = JSON.parse(dong); } catch { return null; }
  if (!j || typeof j !== 'object' || Array.isArray(j)) return null;
  const h = j as Record<string, unknown>;
  const ts = laIso(h.ts);
  if (!ts) return null;
  const kind: LoaiSuKien = typeof h.kind === 'string' && (LOAI_SU_KIEN as readonly string[]).includes(h.kind) ? (h.kind as LoaiSuKienChuan) : 'khac';
  return {
    ts, kind, profile: laChuGon(h.profile, 80), chat: laChuGon(h.chat, 40), model: laChuGon(h.model, 80),
    text: laChuGon(h.text, TOI_DA_CHU_SU_KIEN, true), meta: lamSachMeta(h.meta),
  };
}

/** Cả file events của một ngày → tối đa 400 sự kiện MỚI NHẤT, xếp cũ → mới theo `ts` (cùng giây giữ thứ tự ghi), kèm tổng số dòng đọc được. */
export function lamSachSuKienNgay(tho: string): { ds: SuKienVclaw[]; tong: number } {
  const tat_ca: SuKienVclaw[] = [];
  for (const dong of tho.split('\n')) {
    if (!dong.trim()) continue;
    const s = lamSachSuKien(dong);
    if (s) tat_ca.push(s);
  }
  tat_ca.sort((a, b) => Date.parse(a.ts) - Date.parse(b.ts));
  return { ds: tat_ca.slice(-TOI_DA_DONG), tong: tat_ca.length };
}

// ── Biên bản phòng tác chiến: mỗi dòng một câu nói trong phòng / một thông báo của VClaw ──
/** Biên bản MỘT ngày giữ tối đa chừng này dòng MỚI NHẤT (một cuộc họp 8 người cỡ 30 dòng): ngày nhiều hơn thì cuộc họp CŨ NHẤT của ngày (cuối danh sách xếp mới → cũ) có thể thiếu phần đầu — giao diện nói rõ (`cat`). */
export const TOI_DA_DONG_HOP = 500;
/** Chữ của một dòng: VClaw cắt ở 1500 ký tự (cả dấu …). Dài hơn (tệp bị sửa tay) thì cắt tiếp. */
export const TOI_DA_CHU_HOP = 1500;
/** Dòng JSONL dài hơn mức này (JSON thoát ký tự nở tối đa ~6 lần so với 1 500 ký tự) là rác → bỏ, không parse. */
const TOI_DA_DONG_HOP_THO = 20_000;
/** Người nói: 'owner' (chủ) và 'he-thong' giữ nguyên, còn lại phải đúng mã agent (MAU_MA_AGENT) — không thì '' ("không đọc được"). */
const laNguoiNoiHop = (v: unknown): string => (v === 'owner' || v === 'he-thong' ? v : laMaAgent(v));

/** Một dòng JSONL của warroom/ → DongHop. Dòng hỏng (không phải JSON, quá dài, không có `ts` hợp lệ) → null. `kind` / `room` lạ → 'khac' (giữ dòng: VClaw bản mới hơn VTask vẫn còn thấy lời nói);
 *  `sid` sai dạng → '' (không thuộc cuộc họp nào); `who` sai dạng → ''; `text` giữ xuống dòng, cắt ở TOI_DA_CHU_HOP. So từng giá trị với danh sách đóng — tên lạ (`__proto__`, `constructor`…) không có đường lọt. */
export function lamSachDongHop(dong: string): DongHop | null {
  if (typeof dong !== 'string' || dong.length > TOI_DA_DONG_HOP_THO) return null;
  let j: unknown;
  try { j = JSON.parse(dong); } catch { return null; }
  if (!j || typeof j !== 'object' || Array.isArray(j)) return null;
  const h = j as Record<string, unknown>;
  const ts = laIso(h.ts);
  if (!ts) return null;
  return {
    ts,
    sid: typeof h.sid === 'string' && MAU_MA_HOP.test(h.sid) ? h.sid : '',
    room: PHONG_HOP.find((p) => p === h.room) ?? 'khac',
    who: laNguoiNoiHop(h.who),
    kind: KIEU_TIN_HOP.find((k) => k === h.kind) ?? 'khac',
    text: laVanBanDai(h.text, TOI_DA_CHU_HOP),
  };
}

/** Cả tệp biên bản của một ngày → tối đa TOI_DA_DONG_HOP dòng MỚI NHẤT, xếp cũ → mới theo `ts` (cùng giây giữ thứ tự ghi), kèm tổng số dòng đọc được. */
export function lamSachHopNgay(tho: string): { ds: DongHop[]; tong: number } {
  const tat_ca: DongHop[] = [];
  for (const dong of tho.split('\n')) {
    if (!dong.trim()) continue;
    const d = lamSachDongHop(dong);
    if (d) tat_ca.push(d);
  }
  tat_ca.sort((a, b) => Date.parse(a.ts) - Date.parse(b.ts));
  return { ds: tat_ca.slice(-TOI_DA_DONG_HOP), tong: tat_ca.length };
}

/** ISO cộng `giay` giây; kết quả ngoài miền Date hợp lệ (dữ liệu bậy) → '' thay vì ném RangeError. */
function congGiayIso(iso: string, giay: number): string {
  const ms = Date.parse(iso) + giay * 1000;
  return Number.isFinite(ms) && Math.abs(ms) <= 8.64e15 ? new Date(ms).toISOString() : '';
}

/** Công cụ một việc đã dùng ({"Bash":5,"Read":3}) → mảng {ten, so}, nhiều lượt nhất trước, tối đa 12. Dựng bằng Map + mảng (không bao giờ gán khoá lạ lên đối tượng),
 *  khoá `__proto__` bỏ luôn; tên chỉ MỘT dòng ≤ 40 ký tự; số lượt không dương bị bỏ. */
function lamSachCongCu(tho: unknown): { ten: string; so: number }[] {
  const dem = new Map<string, number>();
  for (const [khoa, v] of Object.entries(laDoiTuong(tho)).slice(0, 100)) {
    const ten = laChuGon(khoa, 40);
    const so = soNguyenKhongAm(v, TRAN_VIEC);
    if (!ten || ten === '__proto__' || so <= 0) continue;
    dem.set(ten, (dem.get(ten) ?? 0) + so);
  }
  return [...dem]
    .map(([ten, so]) => ({ ten, so }))
    .sort((a, b) => b.so - a.so || (a.ten < b.ten ? -1 : a.ten > b.ten ? 1 : 0))
    .slice(0, TOI_DA_CONG_CU_VIEC);
}

/** Một dòng JSONL của jobs/ → ViecSoCai. Dòng hỏng (không phải JSON, quá dài, không có thời điểm hợp lệ) → null. Mọi trường khác thiếu / sai kiểu → rỗng / 0 / null
 *  chứ KHÔNG bỏ dòng: một việc thiếu số liệu vẫn là một việc đã xảy ra. `ts` thiếu → suy từ start + secs; `start` thiếu → suy từ ts − secs.
 *  `kind`: việc xong → '' (dù dòng có ghi gì); việc không xong mà thiếu / lạ → 'unknown'; `ok` không phải boolean → suy từ kind rỗng = xong.
 *  `routine` (mã lịch): chỉ giữ khi đúng dạng slug (MAU_MA_LICH), không thì KHÔNG có khoá này. `agent` (mã agent của đội): cùng quy tắc, theo MAU_MA_AGENT. */
export function lamSachViec(dong: string): ViecSoCai | null {
  if (typeof dong !== 'string' || dong.length > TOI_DA_DONG_SO_CAI) return null;
  let j: unknown;
  try { j = JSON.parse(dong); } catch { return null; }
  if (!j || typeof j !== 'object' || Array.isArray(j)) return null;
  const h = j as Record<string, unknown>;
  const secs = soKhongAm(h.secs, TRAN_GIAY);
  let ts = laIso(h.ts);
  let start = laIso(h.start);
  if (!ts && start) ts = congGiayIso(start, secs);
  if (!ts) return null;
  if (!start) start = congGiayIso(ts, -secs) || ts;
  const loai = typeof h.kind === 'string' ? h.kind : '';
  const ok = typeof h.ok === 'boolean' ? h.ok : loai === '';
  const kind: ViecSoCai['kind'] = ok ? '' : (LOAI_LOI_VIEC as readonly string[]).includes(loai) ? (loai as LoaiLoiViec) : 'unknown';
  const t = laDoiTuong(h.tok);
  const routine = laMaLich(h.routine);
  const agent = laMaAgent(h.agent);
  return {
    ts, start, wait: soKhongAm(h.wait, TRAN_GIAY), secs,
    profile: laChuGon(h.profile, 80), model: laChuGon(h.model, 80),
    ok, kind,
    turns: soNguyenKhongAm(h.turns, TRAN_VIEC), cost: soKhongAm(h.cost, TRAN_CHI_PHI),
    tok: { in: soKhongAm(t.in, TRAN_TOKEN), out: soKhongAm(t.out, TRAN_TOKEN), cr: soKhongAm(t.cr, TRAN_TOKEN), cw: soKhongAm(t.cw, TRAN_TOKEN) },
    tools: lamSachCongCu(h.tools),
    denied: soNguyenKhongAm(h.denied, TRAN_DEM_NHO), retries: soNguyenKhongAm(h.retries, TRAN_DEM_NHO), switches: soNguyenKhongAm(h.switches, TRAN_DEM_NHO),
    resumed: h.resumed === true,
    chat: laChuGon(h.chat, 40), sid: laChuGon(h.sid, 16),
    q5: soHoacNull(h.q5, 100), q7: soHoacNull(h.q7, 100),
    ...(routine ? { routine } : {}), // CHỈ thêm khoá khi mã hợp lệ: việc thường không có trường `routine`
    ...(agent ? { agent } : {}), // như trên: VClaw không bật đội agent (hoặc bản cũ) thì không có trường `agent`
  };
}

/** Cả file jobs của một ngày → tối đa 500 việc MỚI NHẤT, xếp cũ → mới theo `ts` (cùng giây giữ thứ tự ghi), kèm tổng số dòng đọc được. */
export function lamSachViecNgay(tho: string): { ds: ViecSoCai[]; tong: number } {
  const tat_ca: ViecSoCai[] = [];
  for (const dong of typeof tho === 'string' ? tho.split('\n') : []) {
    if (!dong.trim()) continue;
    const v = lamSachViec(dong);
    if (v) tat_ca.push(v);
  }
  tat_ca.sort((a, b) => Date.parse(a.ts) - Date.parse(b.ts));
  return { ds: tat_ca.slice(-TOI_DA_VIEC), tong: tat_ca.length };
}

/** Một dòng JSONL của quota/ → MauQuota. Dòng hỏng / không có `ts` hợp lệ / không có hồ sơ nào đọc được → null.
 *  Mỗi hồ sơ: tên (bỏ mục không tên, trùng tên giữ mục đầu, tối đa 40), f / s = % 5 giờ / 7 ngày (0–100, thiếu → null), seat chỉ true khi đúng `true`,
 *  ok (đăng nhập còn ổn) chỉ false khi đúng `false` — thiếu thì KHÔNG báo "cần đăng nhập" vì không có bằng chứng. */
export function lamSachDongQuota(dong: string): MauQuota | null {
  if (typeof dong !== 'string' || dong.length > TOI_DA_DONG_SO_CAI) return null;
  let j: unknown;
  try { j = JSON.parse(dong); } catch { return null; }
  if (!j || typeof j !== 'object' || Array.isArray(j)) return null;
  const h = j as Record<string, unknown>;
  const ts = laIso(h.ts);
  if (!ts || !Array.isArray(h.p)) return null;
  const p: DiemQuotaHoSo[] = [];
  const da_co = new Set<string>();
  for (const x of h.p.slice(0, 100)) { // quét có trần: phần tử rác không chiếm chỗ của hồ sơ thật
    if (p.length >= TOI_DA_HO_SO_QUOTA) break;
    const o = laDoiTuong(x);
    const n = laChuGon(o.n, 80);
    if (!n || da_co.has(n)) continue;
    da_co.add(n);
    p.push({ n, f: soHoacNull(o.f, 100), s: soHoacNull(o.s, 100), seat: o.seat === true, ok: o.ok !== false });
  }
  return p.length > 0 ? { ts, p } : null;
}

/** Giảm một dãy (đã xếp theo thời gian) xuống còn tối đa `toi_da` phần tử: lấy đều theo THỨ TỰ, luôn giữ phần tử đầu và cuối. Ngắn hơn thì giữ nguyên. */
export function giamMauDeu<T>(ds: T[], toi_da: number): T[] {
  const tran = Number.isFinite(toi_da) ? Math.max(2, Math.floor(toi_da)) : TOI_DA_MAU_QUOTA;
  if (ds.length <= tran) return ds;
  const buoc = (ds.length - 1) / (tran - 1);
  return Array.from({ length: tran }, (_, k) => ds[Math.round(k * buoc)]);
}

/** Các tệp quota của MỘT khoảng (một hoặc nhiều tệp ngày, văn bản thô) → mẫu nằm trong [tu, den] (epoch ms), xếp cũ → mới, trùng `ts` giữ mẫu đầu,
 *  rồi giảm xuống tối đa `toi_da` mẫu (mặc định 400, xem giamMauDeu). Dòng hỏng bỏ. `tu`/`den` không phải số → không mẫu nào lọt qua. */
export function lamSachMauQuota(tho: string | string[], khoang: { tu: number; den: number }, toi_da: number = TOI_DA_MAU_QUOTA): MauQuota[] {
  const cac_tep = typeof tho === 'string' ? [tho] : Array.isArray(tho) ? tho : [];
  const mau: MauQuota[] = [];
  for (const tep of cac_tep) {
    if (typeof tep !== 'string') continue;
    for (const dong of tep.split('\n')) {
      if (!dong.trim()) continue;
      const m = lamSachDongQuota(dong);
      if (!m) continue;
      const t = Date.parse(m.ts);
      if (t >= khoang.tu && t <= khoang.den) mau.push(m);
    }
  }
  mau.sort((a, b) => Date.parse(a.ts) - Date.parse(b.ts));
  const khong_trung: MauQuota[] = [];
  for (const m of mau) if (khong_trung.length === 0 || Date.parse(khong_trung[khong_trung.length - 1].ts) !== Date.parse(m.ts)) khong_trung.push(m);
  return giamMauDeu(khong_trung, toi_da);
}

/** Các ngày (giờ VN, cũ → mới) mà tệp quota có thể chứa mẫu của khoảng 6h / 24h / 7d kết thúc ở `bay_gio`: tối đa 8 tệp (7 ngày × 24 giờ trải trên 8 ngày lịch). */
export function ngayQuotaTrongKhoang(khoang: KhoangQuota, bay_gio: number): string[] {
  const den = homNayVn(bay_gio);
  const tu = homNayVn(bay_gio - KHOANG_QUOTA[khoang]);
  const ra: string[] = [];
  for (let n = tu; n <= den && ra.length < 8; n = congNgay(n, 1)) ra.push(n);
  return ra;
}

/** memory/index.json → chỉ mục đã làm sạch. Không có mảng `items` → null. Mục sai loại / không có id bị bỏ; trùng id giữ mục đầu; tối đa 400 mục. */
export function lamSachChiMucBoNho(tho: unknown): ChiMucBoNho | null {
  const t = laDoiTuong(tho);
  if (!Array.isArray(t.items)) return null;
  const items: MucBoNho[] = [];
  const da_co = new Set<string>();
  for (const x of t.items.slice(0, TOI_DA_MUC_BO_NHO)) {
    const o = laDoiTuong(x);
    const id = laChuGon(o.id, 200);
    if (!id || da_co.has(id) || typeof o.type !== 'string' || !(LOAI_BO_NHO as readonly string[]).includes(o.type)) continue;
    da_co.add(id);
    const tags: string[] = [];
    if (Array.isArray(o.tags)) {
      for (const g of o.tags.slice(0, 12)) {
        const tag = laChuGon(g, 40);
        if (tag && !tags.includes(tag)) tags.push(tag);
      }
    }
    items.push({
      id, type: o.type as LoaiBoNho,
      title: laChuGon(o.title, 160, true) || (id.split('/').pop() ?? id).replace(/\.md$/i, ''),
      date: typeof o.date === 'string' && laNgayHopLe(o.date) ? o.date : '',
      tags, summary: laChuGon(o.summary, 240, true),
    });
  }
  const cn = laDoiTuong(t.counts);
  const counts = {} as Record<LoaiBoNho, number>;
  for (const loai of LOAI_BO_NHO) counts[loai] = laSo(cn[loai]) === null ? items.filter((m) => m.type === loai).length : soNguyenKhongAm(cn[loai], TRAN_VIEC);
  return { updated: laIso(t.updated), hub: laChuGon(t.hub, 40), counts, items };
}

// ── Biểu đồ token / chi phí: dựng chuỗi theo ngày + gộp ──
export type ChiSoBieuDo = 'token' | 'chi-phi' | 'viec';
/** Số hồ sơ có màu riêng (khớp --chuoi-1…6 trong index.css); hồ sơ thứ 7 trở đi gộp vào "Khác". */
export const TOI_DA_MAU_HO_SO = 6;
export type SeriesBieuDo = { ten: string; /** vị trí màu 0…5, null = xám trung tính ("Khác") */ slot: number | null };
export type ChuoiBieuDo = {
  ngay: string[];
  series: SeriesBieuDo[];
  /** gia_tri[ngày][series] */
  gia_tri: number[][];
  tong_ngay: number[];
  /** Số liệu gốc của từng ngày (null = VClaw không ghi gì ngày đó) — cho tooltip/bảng. */
  ngay_chi_tiet: (NgaySuDung | null)[];
  cao_nhat: number;
  /** Số hồ sơ bị gộp vào "Khác" vì hết màu. */
  so_ho_so_gop: number;
};

export const giaTriChiSo = (chi_so: ChiSoBieuDo, o: { jobs: number; in: number; out: number; cost: number }): number =>
  chi_so === 'viec' ? o.jobs : chi_so === 'chi-phi' ? o.cost : o.in + o.out;

/** Thứ tự hồ sơ ỔN ĐỊNH để gán màu (màu theo hồ sơ, không theo hạng: đổi 14/30 ngày hay đổi chỉ số không được đổi màu hồ sơ nào):
 *  trước hết theo thứ tự `thu_tu` (thứ tự xoay seat của VClaw), phần còn lại theo ABC. Lấy tên từ TOÀN BỘ dữ liệu, không riêng khoảng đang xem. */
export function thuTuHoSo(su_dung: SuDungVclaw | null, thu_tu: string[] = []): string[] {
  const co = new Set<string>();
  for (const d of su_dung?.days ?? []) for (const p of d.by_profile) co.add(p.name);
  const dau = thu_tu.filter((t, i) => co.has(t) && thu_tu.indexOf(t) === i);
  const con_lai = [...co].filter((t) => !dau.includes(t)).sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
  return [...dau, ...con_lai];
}

/** Chuỗi cho biểu đồ cột xếp chồng: `so_ngay` ngày kết thúc ở `hom_nay` (ngày không có số liệu = 0). Mỗi cột = các hồ sơ có màu + "Khác"
 *  (hồ sơ hết màu + phần tổng của ngày mà theo-hồ-sơ chưa nói tới), nên tổng cột luôn khớp tổng ngày. Series không có giá trị nào trong khoảng thì bỏ. */
export function chuoiTheoNgay(su_dung: SuDungVclaw | null, so_ngay: number, hom_nay: string, chi_so: ChiSoBieuDo, thu_tu: string[] = []): ChuoiBieuDo {
  const ngay: string[] = [];
  // so_ngay và hom_nay do nơi gọi truyền (14 / 30 / homNayVn()) — vẫn chặn giá trị bậy để không treo trang hay ném RangeError.
  const ket_thuc = laNgayHopLe(hom_nay) ? hom_nay : homNayVn();
  const dem = Number.isFinite(so_ngay) ? Math.min(366, Math.max(1, Math.floor(so_ngay))) : 1;
  for (let i = dem - 1; i >= 0; i--) ngay.push(congNgay(ket_thuc, -i));
  const theo_ngay = new Map((su_dung?.days ?? []).map((d) => [d.day, d] as const));
  const tat_ca = thuTuHoSo(su_dung, thu_tu);
  const co_mau = tat_ca.slice(0, TOI_DA_MAU_HO_SO);
  const ngay_chi_tiet = ngay.map((n) => theo_ngay.get(n) ?? null);
  const bang = ngay_chi_tiet.map((d) => {
    const hang = new Array<number>(co_mau.length + 1).fill(0);
    if (!d) return hang;
    let da_ke = 0;
    for (const p of d.by_profile) {
      const v = giaTriChiSo(chi_so, p);
      da_ke += v;
      const i = co_mau.indexOf(p.name);
      hang[i >= 0 ? i : co_mau.length] += v;
    }
    // Phần tổng của ngày mà theo-hồ-sơ chưa nói tới → "Khác". Sai số dấu phẩy động (0.1+0.2) không được sinh ra một cột "Khác" ma.
    const du = giaTriChiSo(chi_so, d) - da_ke;
    if (du > 1e-6) hang[co_mau.length] += du;
    return hang;
  });
  const khac = co_mau.length;
  const cot: number[] = [];
  for (let i = 0; i <= khac; i++) if (bang.some((h) => h[i] > 0)) cot.push(i);
  const series: SeriesBieuDo[] = cot.map((i) => (i < khac ? { ten: co_mau[i], slot: i } : co_mau.length ? { ten: 'Khác', slot: null } : { ten: 'Tất cả hồ sơ', slot: 0 }));
  const gia_tri = bang.map((h) => cot.map((i) => h[i]));
  const tong_ngay = gia_tri.map((h) => h.reduce((a, b) => a + b, 0));
  return { ngay, series, gia_tri, tong_ngay, ngay_chi_tiet, cao_nhat: Math.max(0, ...tong_ngay), so_ho_so_gop: Math.max(0, tat_ca.length - TOI_DA_MAU_HO_SO) };
}

export type TongSuDung = { jobs: number; failed: number; in: number; out: number; cache_read: number; cache_write: number; cost: number; secs: number; so_ngay: number };
/** Tổng các ngày có số liệu (ô `null` = ngày VClaw không ghi gì, bỏ qua). */
export function tongSuDung(ds: (NgaySuDung | null)[]): TongSuDung {
  const t: TongSuDung = { jobs: 0, failed: 0, in: 0, out: 0, cache_read: 0, cache_write: 0, cost: 0, secs: 0, so_ngay: 0 };
  for (const d of ds) {
    if (!d) continue;
    t.so_ngay++;
    t.jobs += d.jobs; t.failed += d.failed; t.in += d.in; t.out += d.out; t.cache_read += d.cache_read; t.cache_write += d.cache_write; t.cost += d.cost; t.secs += d.secs;
  }
  return t;
}

/** Gộp theo hồ sơ qua nhiều ngày; nhiều chi phí / token nhất trước. */
export function gomTheoHoSo(ds: (NgaySuDung | null)[]): SuDungHoSo[] {
  const m = new Map<string, SuDungHoSo>();
  for (const d of ds) for (const p of d?.by_profile ?? []) {
    const c = m.get(p.name) ?? { name: p.name, jobs: 0, in: 0, out: 0, cost: 0 };
    m.set(p.name, { name: p.name, jobs: c.jobs + p.jobs, in: c.in + p.in, out: c.out + p.out, cost: c.cost + p.cost });
  }
  return [...m.values()].sort((a, b) => b.cost - a.cost || b.in + b.out - (a.in + a.out) || b.jobs - a.jobs || (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
}

/** Gộp theo model qua nhiều ngày; nhiều việc nhất trước. */
export function gomTheoModel(ds: (NgaySuDung | null)[]): SuDungModel[] {
  const m = new Map<string, SuDungModel>();
  for (const d of ds) for (const p of d?.by_model ?? []) {
    const c = m.get(p.name) ?? { name: p.name, jobs: 0, cost: 0 };
    m.set(p.name, { name: p.name, jobs: c.jobs + p.jobs, cost: c.cost + p.cost });
  }
  return [...m.values()].sort((a, b) => b.jobs - a.jobs || b.cost - a.cost || (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
}

/** Tên file `YYYY-MM-DD.jsonl` → mảng ngày, mới nhất trước. */
export function ngayTuTenTep(ten: string[]): string[] {
  return ten.map((t) => /^(\d{4}-\d{2}-\d{2})\.jsonl$/.exec(t)?.[1]).filter((n): n is string => !!n && laNgayHopLe(n)).sort().reverse();
}


/** `chats/YYYY/MM` của tháng chứa `ngay` và tháng liền trước (đủ để liệt kê ~30–60 ngày gần nhất). */
export function thuMucThang(ngay: Date): string[] {
  const out: string[] = [];
  for (let lui = 0; lui < 2; lui++) {
    const d = new Date(Date.UTC(ngay.getUTCFullYear(), ngay.getUTCMonth() - lui, 1));
    out.push(`chats/${d.getUTCFullYear()}/${String(d.getUTCMonth() + 1).padStart(2, '0')}`);
  }
  return out;
}
export const duongNgay = (ngay: string) => `chats/${ngay.slice(0, 4)}/${ngay.slice(5, 7)}/${ngay}.jsonl`;
/** Chỉ gọi với ngày đã qua `laNgayHopLe` — không bao giờ nối chuỗi lạ vào đường dẫn. */
export const duongSuKien = (ngay: string) => `events/${ngay.slice(0, 4)}/${ngay.slice(5, 7)}/${ngay}.jsonl`;
/** Sổ cái việc của một ngày (giờ VN) và các mẫu quota của ngày đó. Cùng điều kiện: chỉ gọi với ngày đã qua `laNgayHopLe`. */
export const duongViec = (ngay: string) => `jobs/${ngay.slice(0, 4)}/${ngay.slice(5, 7)}/${ngay}.jsonl`;
export const duongQuota = (ngay: string) => `quota/${ngay.slice(0, 4)}/${ngay.slice(5, 7)}/${ngay}.jsonl`;
/** Biên bản phòng tác chiến của một ngày (giờ VN). Cùng điều kiện: chỉ gọi với ngày đã qua `laNgayHopXem` / `laNgayHopLe`. */
export const duongHop = (ngay: string) => `warroom/${ngay.slice(0, 4)}/${ngay.slice(5, 7)}/${ngay}.jsonl`;
export const DUONG_BO_NHO = 'memory/index.json';

// ── Tìm chat nhiều ngày (GET /api/vclaw/tim): HÀM THUẦN dùng chung cho máy chủ (tìm, cắt đoạn trích) và giao diện (làm nổi từ khoá, lọc trong ngày). ──
// MỘT hàm gập chữ duy nhất (gapChuTim) cho cả ba nơi: nếu máy chủ gập khác ô "Tìm trong ngày" thì một kết quả máy chủ báo khớp có thể bị ô lọc loại ra khi bấm sang xem.
// Gập = không phân biệt hoa thường, bỏ dấu tiếng Việt (đ → d), mọi khoảng trắng / ký tự điều khiển liền nhau thành MỘT dấu cách. Kết quả luôn báo trên văn bản GỐC.
export const NGAY_TIM_CHO_PHEP = [7, 14, 30] as const;
export type SoNgayTim = (typeof NGAY_TIM_CHO_PHEP)[number];
export const NGAY_TIM_MAC_DINH: SoNgayTim = 7;
export const TOI_THIEU_TU_KHOA = 2;
export const TOI_DA_TU_KHOA = 80;
export const TOI_DA_KET_QUA_TIM = 100;
/** Đoạn trích tối đa, TÍNH CẢ dấu … ở hai đầu. */
export const TOI_DA_DOAN = 240;
/** Mỗi lượt tìm đọc tối đa chừng này tệp ngày (mỗi tệp một lời gọi GitHub; Cloudflare giới hạn số lời gọi con của một yêu cầu). */
export const TOI_DA_TEP_TIM = 30;
/** Số tệp ngày đọc CÙNG LÚC. */
export const DONG_THOI_TIM = 6;
/** Một tin chỉ xét tối đa chừng này ký tự (VClaw tự cắt ở 20 000; dòng bị sửa tay dài hơn thì bỏ phần thừa). */
const TOI_DA_CHU_TIM = 50_000;
/** Dòng JSONL dài hơn mức này (JSON thoát ký tự nở tối đa ~6 lần so với 20 000 ký tự) là rác → bỏ, không parse. */
const TOI_DA_DONG_TIM = 300_000;
export type HuongTin = DongChat['dir'];
export const HUONG_TIN: readonly HuongTin[] = ['in', 'out', 'sys'];

/** Dạng so khớp của MỘT ký tự (theo điểm mã): ASCII hạ chữ thường, khoảng trắng / ký tự điều khiển → ' ', dấu kết hợp (U+0300–U+036F) → '' , đ → d, còn lại hạ chữ rồi tách dấu (NFD).
 *  Không dùng mã thoát \u trong nguồn (repo cấm ký tự tổ hợp thô): khoảng dấu kiểm bằng số. */
const BO_NHO_GAP = new Map<number, string>();
function gapMaDiem(cp: number): string {
  if (cp < 128) {
    if (cp <= 32 || cp === 127) return ' ';
    return String.fromCharCode(cp >= 65 && cp <= 90 ? cp + 32 : cp);
  }
  const da_co = BO_NHO_GAP.get(cp);
  if (da_co !== undefined) return da_co;
  const ky_tu = String.fromCodePoint(cp);
  let ra = '';
  if (cp <= 0x9f || /\s/.test(ky_tu)) {
    ra = ' ';
  } else {
    for (const u of ky_tu.toLowerCase().normalize('NFD')) {
      const k = u.codePointAt(0)!;
      if (k < 0x300 || k > 0x36f) ra += u === 'đ' ? 'd' : u;
    }
  }
  if (BO_NHO_GAP.size > 20_000) BO_NHO_GAP.clear(); // dữ liệu bậy (hàng chục nghìn ký tự khác nhau) không được làm bộ nhớ phình mãi
  BO_NHO_GAP.set(cp, ra);
  return ra;
}

/** Gập một chuỗi để so khớp (xem đầu mục). Có `ban_do` thì ghi thêm, cho TỪNG đơn vị UTF-16 của chuỗi đã gập, đoạn [bd, kt) tương ứng trong chuỗi GỐC:
 *  ký tự gập ra nhiều đơn vị thì cả hai cùng trỏ về ký tự gốc; dấu kết hợp và dãy khoảng trắng bị nuốt thì vùng của ký tự đứng trước được nới ra ôm cả chúng
 *  (vùng làm nổi không bao giờ tách chữ khỏi dấu của nó). Lặp theo ĐIỂM MÃ nên cặp thay thế (emoji) không bị chẻ đôi. Không phải chuỗi → ''. */
export function gapChuTim(s: string, ban_do?: { bd: number[]; kt: number[] }): string {
  if (typeof s !== 'string') return '';
  let g = '';
  let i = 0;
  let sau_cach = false;
  while (i < s.length) {
    const cp = s.codePointAt(i)!;
    const dai = cp > 0xffff ? 2 : 1;
    const f = gapMaDiem(cp);
    if (f === ' ') {
      if (sau_cach) {
        if (ban_do) ban_do.kt[ban_do.kt.length - 1] = i + dai;
      } else {
        g += ' ';
        sau_cach = true;
        if (ban_do) { ban_do.bd.push(i); ban_do.kt.push(i + dai); }
      }
    } else if (f === '') {
      if (ban_do && ban_do.kt.length > 0) ban_do.kt[ban_do.kt.length - 1] = i + dai;
    } else {
      g += f;
      sau_cach = false;
      if (ban_do) for (let k = 0; k < f.length; k++) { ban_do.bd.push(i); ban_do.kt.push(i + dai); }
    }
    i += dai;
  }
  return g;
}

/** Từ khoá đã gập và cắt hai đầu. Không phải chuỗi / toàn khoảng trắng hoặc dấu rời → '' (nơi gọi coi là "không có từ khoá"). */
export const chuanHoaTuKhoa = (q: unknown): string => (typeof q === 'string' ? gapChuTim(q).trim() : '');

/** Bộ khớp dựng sẵn từ một từ khoá (gập từ khoá MỘT lần, dùng cho cả danh sách tin). Từ khoá rỗng → khớp mọi chuỗi. */
export function taoBoKhop(q: unknown): (van_ban: unknown) => boolean {
  const qf = chuanHoaTuKhoa(q);
  return (van_ban) => qf === '' || (typeof van_ban === 'string' && gapChuTim(van_ban).includes(qf));
}

/** MỌI chỗ `q` khớp trong `van_ban`, báo trên văn bản GỐC: mảng [bắt đầu, kết thúc) theo đơn vị UTF-16, tăng dần, không chồng nhau, tối đa `toi_da` chỗ.
 *  Từ khoá rỗng / văn bản rỗng / không phải chuỗi → []. Giao diện dùng chính hàm này để tách đoạn trích thành các phần chữ thường + phần làm nổi (không chèn HTML). */
export function viTriKhop(van_ban: unknown, q: unknown, toi_da = 20): [number, number][] {
  const qf = chuanHoaTuKhoa(q);
  if (!qf || typeof van_ban !== 'string' || van_ban === '' || !(toi_da >= 1)) return [];
  const ban_do = { bd: [] as number[], kt: [] as number[] };
  const g = gapChuTim(van_ban, ban_do);
  const ra: [number, number][] = [];
  for (let tu = g.indexOf(qf); tu !== -1 && ra.length < toi_da; tu = g.indexOf(qf, tu + qf.length)) {
    ra.push([ban_do.bd[tu], ban_do.kt[tu + qf.length - 1]]);
  }
  return ra;
}

const laDauKetHop = (ma: number) => ma >= 0x300 && ma <= 0x36f;
const laNuaSauCapThayThe = (ma: number) => ma >= 0xdc00 && ma <= 0xdfff;

/** Đoạn trích của văn bản MỘT DÒNG `gon` quanh vùng khớp [tu, den): tối đa `toi_da` ký tự TÍNH CẢ dấu … ở đầu / cuối khi có cắt (mặc định 240). Căn giữa vùng khớp;
 *  không cắt giữa cặp thay thế (emoji), không bắt đầu bằng dấu kết hợp rời, không để chữ gốc ở cuối đoạn mất dấu. Ngắn hơn mức này thì trả nguyên. Vùng khớp dài hơn chỗ cho phép thì đoạn bắt đầu từ chỗ khớp. */
export function catDoan(gon: string, tu: number, den: number, toi_da: number = TOI_DA_DOAN): string {
  if (typeof gon !== 'string') return '';
  const tran = Number.isFinite(toi_da) ? Math.max(8, Math.floor(toi_da)) : TOI_DA_DOAN;
  if (gon.length <= tran) return gon;
  const t = Math.min(Math.max(0, Number.isFinite(tu) ? Math.floor(tu) : 0), gon.length);
  const d = Math.min(Math.max(t, Number.isFinite(den) ? Math.floor(den) : t), gon.length);
  const cho = tran - 2; // chỗ cho phần chữ: để sẵn hai dấu …
  const dai_khop = d - t;
  let b = Math.min(gon.length, (dai_khop >= cho ? t : Math.max(0, t - Math.floor((cho - dai_khop) / 2))) + cho);
  let a = Math.max(0, b - cho);
  while (a < t && laDauKetHop(gon.charCodeAt(a))) a++;
  while (b > d && b < gon.length && laDauKetHop(gon.charCodeAt(b))) b--;
  if (a > 0 && a < t && laNuaSauCapThayThe(gon.charCodeAt(a))) a++;
  if (b > d && b < gon.length && laNuaSauCapThayThe(gon.charCodeAt(b))) b--;
  return (a > 0 ? '…' : '') + gon.slice(a, b) + (b < gon.length ? '…' : '');
}

export type KetQuaTimChat = { ngay: string; ts: string; dir: HuongTin; doan: string };

/** Một dòng chats/ → {ts, ms, dir, text} CHO VIỆC TÌM. Khác lamSachDong: KHÔNG cắt còn 4 000 ký tự (VClaw ghi tới 20 000 ký tự một tin; cắt sớm thì tin dài mất kết quả
 *  ở đoạn sau, và dấu "… (đã cắt bớt)" lại khớp nhầm mọi từ khoá giống nó). Dòng hỏng / không có thời điểm hợp lệ / không có chữ → null. */
function docDongTim(dong: string): { ts: string; ms: number; dir: HuongTin; text: string } | null {
  if (dong.length > TOI_DA_DONG_TIM) return null;
  let j: unknown;
  try { j = JSON.parse(dong); } catch { return null; }
  if (!j || typeof j !== 'object' || Array.isArray(j)) return null;
  const h = j as Record<string, unknown>;
  const ts = laIso(h.ts);
  if (!ts || typeof h.text !== 'string') return null;
  return { ts, ms: Date.parse(ts), dir: h.dir === 'in' || h.dir === 'out' ? h.dir : 'sys', text: h.text.length > TOI_DA_CHU_TIM ? h.text.slice(0, TOI_DA_CHU_TIM) : h.text };
}

/** Tìm `q` trong MỘT tệp chats/ (văn bản thô của cả ngày). Hai pha để CPU không phụ thuộc số tin khớp: (1) mỗi dòng chỉ gập chữ rồi kiểm có chứa từ khoá; (2) chỉ `tran` tin MỚI NHẤT
 *  (theo `ts`, cùng giây thì dòng ghi sau lên trước) mới được dựng đoạn trích. `tong` = số tin khớp của cả ngày (đủ, không bị cắt). `loai` lọc theo hướng tin; ngày không có thật hoặc
 *  từ khoá rỗng → không kết quả. `ms` là mốc `ts` (epoch) để nơi gọi trộn nhiều ngày — không đưa ra ngoài. */
export function timTrongNgay(ngay: string, tho: string, q: unknown, loai: readonly HuongTin[] = HUONG_TIN, tran: number = TOI_DA_KET_QUA_TIM): { ds: (KetQuaTimChat & { ms: number })[]; tong: number } {
  const qf = chuanHoaTuKhoa(q);
  if (!qf || typeof tho !== 'string' || typeof ngay !== 'string' || !laNgayHopLe(ngay)) return { ds: [], tong: 0 };
  const dong = tho.split('\n');
  const trung: { ms: number; i: number }[] = [];
  for (let i = 0; i < dong.length; i++) {
    if (!dong[i].trim()) continue;
    const r = docDongTim(dong[i]);
    if (r && loai.includes(r.dir) && gapChuTim(r.text).includes(qf)) trung.push({ ms: r.ms, i });
  }
  trung.sort((a, b) => b.ms - a.ms || b.i - a.i);
  const ds: (KetQuaTimChat & { ms: number })[] = [];
  for (const { i } of trung.slice(0, Number.isFinite(tran) ? Math.max(0, Math.floor(tran)) : TOI_DA_KET_QUA_TIM)) {
    const r = docDongTim(dong[i]);
    if (!r) continue;
    const gon = laChuGon(r.text, Infinity);
    const [khop] = viTriKhop(gon, qf, 1);
    ds.push({ ngay, ts: r.ts, ms: r.ms, dir: r.dir, doan: khop ? catDoan(gon, khop[0], khop[1]) : catDoan(gon, 0, 0) });
  }
  return { ds, tong: trung.length };
}

export type ThamSoTim = { q: string; ngay: SoNgayTim; loai: HuongTin[] };

/** Tham số của /api/vclaw/tim → đã làm sạch, hoặc null nếu SAI (nơi gọi trả 400 và KHÔNG gọi GitHub).
 *  q: bắt buộc, sau khi gộp khoảng trắng + cắt hai đầu dài 2–80 ký tự VÀ sau khi gập chữ vẫn ≥ 2 (một chữ "đ", hay toàn dấu rời, không đủ). Chuỗi gửi lên dài quá 400 ký tự bị loại ngay.
 *  ngay: đúng "7" | "14" | "30" (thiếu / để trống → 7). loai: danh sách in,out,sys cách nhau bởi dấu phẩy (thiếu / để trống → cả ba); giá trị lạ → sai. */
export function lamSachThamSoTim(q_tho: unknown, ngay_tho: unknown, loai_tho: unknown): ThamSoTim | null {
  if (typeof q_tho !== 'string' || q_tho.length > 400) return null;
  const q = laChuGon(q_tho, Infinity);
  if (q.length < TOI_THIEU_TU_KHOA || q.length > TOI_DA_TU_KHOA || chuanHoaTuKhoa(q).length < TOI_THIEU_TU_KHOA) return null;
  let ngay: SoNgayTim = NGAY_TIM_MAC_DINH;
  if (ngay_tho !== null && ngay_tho !== undefined && ngay_tho !== '') {
    const n = NGAY_TIM_CHO_PHEP.find((x) => String(x) === ngay_tho);
    if (n === undefined) return null;
    ngay = n;
  }
  let loai: HuongTin[] = [...HUONG_TIN];
  if (loai_tho !== null && loai_tho !== undefined && loai_tho !== '') {
    if (typeof loai_tho !== 'string' || loai_tho.length > 40) return null;
    const chon = new Set<HuongTin>();
    for (const t of loai_tho.split(',')) {
      const h = HUONG_TIN.find((x) => x === t); // so từng giá trị, không tra khoá đối tượng: `__proto__` và bạn bè không có đường lọt vào
      if (!h) return null;
      chon.add(h);
    }
    loai = HUONG_TIN.filter((x) => chon.has(x));
  }
  return { q, ngay, loai };
}
